export const environmentData = {
  //#region Global values
  email_error_msg: 'Invalid E-Mail',
  home_phone_no_error_msg: 'Home Phone No is required',
  contact_num_min_error_msg: 'Must contain 10 digits',
  ext_or_contact_num_pattern_error_msg: 'In digits',
  ext_error_msg: 'Only digits or + followed by digits',
  ext_max_error_msg: 'Max 5',
  ssn_error_msg: 'Must contain 9 digits',
  future_date_error_msg: 'Future Date Not Allowed',
  past_date_error_msg: 'Past Date Not Allowed',
  date_format_error_msg: 'Required MM/DD/YYYY',
  version: ' 0.5 (Beta)',

  transmitMail: 'imperiumsoft-edge2015@directtest.interopengine.com',
  transmitPassword: 'SM84ZSJOxzby0cmK0JxOJg==',

  // Date Formatter
  us_date_format: 'MM/dd/yyyy',
  time_format: 'HH:mm',
  date_time_format: 'MM/dd/yyyy HH:mm',
  date_time_with_sec_format: 'MM/dd/yyyy HH:mm:ss',
  year_format: 'yyyy',
  month_year_format: 'MM/yyyy',
  month_date_format: 'MM/dd',
  min_date: new Date(new Date().getFullYear() - 150, new Date().getMonth(), new Date().getDate()), // changed the min date veerereddy to 150 year's back

  emailPattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$",
  // emailPattern: "/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\.[a-zA-Z]{2,}$/",

  mouseover_delay_time: 500,

  idle_time: 600,
  idle_timeout: 120,
  ag_grid_row_height: 30,
  ag_grid_header_height: 32,

  MY_DATE_FORMATS: {
    parse: {
      dateInput: 'MM/dd/yyyy',
    },
    display: {
      dateInput: 'MM/dd/yyyy',
      monthYearLabel: 'MM yyyy',
      dateA11yLabel: 'MM/dd/yyyy',
      monthYearA11yLabel: 'MM yyyy',
    },
  },
  MY_OWL_FORMATS: {
    fullPickerInput: 'MM/DD/YYYY HH:mm',
    parseInput: 'MM/DD/YYYY HH:mm',
    datePickerInput: 'MM/DD/YYYY HH:mm',
    timePickerInput: 'HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },

  pharmacistHomeModuleId: 10001,
  pharmacistHomePageId: 10002,

  icdCodeKey: 'icdCode',
  icd9CodeKey: 'icD9CM',
  icd10CodeKey: 'icD10Code',
  snomedCodeKey: 'conceptId',
  cptCodeKey: 'cptCode',
  loincCodeKey: 'loinC_NUM',
  //#endregion Global Values

  //#region Image DB -----------------------------------------------------------------------------------------
  imageLogin: 'Login/Login',
  imagePath: 'Images',
  sannedPatth:'patient',
  //#endregion Image DB --------------------------------------------------------------------------------------

  // Master Controller:
  //Get Methods
  visitType:'Common/VisitType',
  patientMenu: 'Menus/Workflow',
  orderResultsTree: 'LabResults/OrdersResultsTree',
  orderResults: 'LabResults/OrdersResults',
  orderResultsHistory: 'LabResults/OrdersResultsLastViewed',
  authenticate: 'Login/Validate',
  DirectMessegeLoginauthenticate: 'EMRDirectMail/DirectMailValidate',
  generateOtpByCellNumber:'Login/OTPGeneration',
  loginByCellNumber:'Login/ValidateUserOtp',
  MasterController: 'Master',
  telecomUseCode: `Common/TelecomUseCode`,
  telecomEquipmentType: 'Common/TelecomEquipmentType',
  insuranceBranches: 'Master/InsAllBranches',
  insuranceTypeCodes: 'Master/InsTypeCodes',
  financialClasses: 'Common/FinClasses',
  employmentStatus: 'Common/EmploymentStatus',
  PatientTypes: 'Common/PatientTypes',
  PatientStatus: 'Common/PatientStatus',
  patientMerge: 'Patient/PatientMerge',
  PatientAdmisionSource: 'Master/AdmisionSourceV1',//SR1
  PatientAccomodation: 'Common/PatientAccomodation',
  HosptialServiceType: 'Common/HosptialServiceType',
  PatientArrivedby: 'Common/PatientArrivedby',
  AccidentOccerence: 'Common/AccidentOccerence',
  FunctionViewsModule:'AssignPermission/FunctionViewsModule',
  race: 'Master/RaceV1',  //'Master/Race', //  from kalyani api
  patientRace:'Patient/PatientRace',
  ethnicity: 'Master/EthnicityV1',
  relationType: 'Master/RelationShipV1',
  bedLevelOfCare:'Master/LevelOfCare',

  cities: 'Master/ZipCodesByCity',
  states: 'Master/ZipCodesByState',
  DeliveryTypes: 'Master/DeliveryTypes',
  countries: 'Master/ZipCodesByCountry',
  zipcodes: 'Master/ZipCodesByZip',
  SearchPharmacy: 'Master/SearchPharmacy',//SearchPharmacy?PharmacyType=MailOrder&StoreName=null&City=Palmetto&State=null&Zip=null&Fax=null
  maritalStatus: 'Master/MaritalStatusV1',
  nameOfCodingSystem:'Master/CodingSystem',
  tribalEntity:'Master/TribalEntity',
  speciesCodes:'Master/Animal_CDC',
  PatientAdmissionTypes: 'Common/PatientAdmissionTypes',
  PatientIsExpiredData: 'Patient/PatientExpiryInfo',
  professionalSuffix: 'Common/ProfessionalSuffix',
  reviewOrder:'Staff/ReviewOrder',
  nameType: 'Master/NameTypeV1', //SR1
  religion: 'Master/ReligionV1',
  language: 'Master/Language',
  employmentType: 'Master/employmenttype',
  staffProfileUpdate:'Staff/UpdateStaffDetails',

  primaryPhysician: 'Master/primaryphysician',
  UserMenu: 'Common/UserMenu',
  Departments: 'Common/Departments',
  // referringPhysicians: 'emr/master/refphysician',
  referralPhysicians: 'Physicians/RefPhysician',
  radiologyPhysicians:'Scheduler/RadiologyPhysicians',
  radiologyResourceLocations:'Scheduler/RadResourceLocations',
  resourceMnemonicDuplicate:'Scheduler/ResourceMnemonicStatus',
  resourceLocationDuplicate:'Scheduler/ResourceLocNameStatus',
  masterClinics:'Master/Clinics',
  referringPhysicians: 'Physicians/RefPhysician',
  dispositionDetailsAudit:'Discharge/DispositionDetailsAudit',
  npiSearchPhysicians:'Physicians/NPIPrimaryPhysician',
  updateRefPhysician:'Physicians/UpdateRef',
  AllRefPhysicians:'Physicians/AllRefPhysicians',
  deleteReferPhysician:'Physicians/DeleteRefDoctor',
  primaryAttendingDoctor: 'Physicians/PrimaryDoctor',
  AllPhysicians: 'Physicians/AllPhysicianWithSameLocation',
  AdmitDecisionSave: 'Physicians/AdmitDecision',//admitDecisinSave
  DischargeCondition: 'discharge/DischargeCondition',
  ReasonForDischarge: 'discharge/DischargeReasons',
 cancelPatientDischarge: 'Discharge/CancelPatientDischarge',
  //DispositionSave:'Discharge/PatientDisposition',//mouni created, now  deprecated by kondaiah
  DispositionDetails: 'Discharge/DispositionDetails', // new service for disposition given by kondaiah, updated sreenivas
  PatientMarMedicationDataByMarId: 'NurseActions/PatientMarMedicationDataByMarId',

  login: 'auth/authenticate',
  gender: 'Master/GenderV1', //  changed by sirisha giving from pavani said by ramu sir
  addressType: 'Master/AddressTypeV1',
  singleAddresss:'Patient/PatientAddressInfo',
  updateERPhoneInfo:'Patient/PatientInfoUpdate',
  AccidentPlace: 'Common/AccidentPlace',
  HealthcareUnits: 'Master/HealthcareUnits',
  PharmacyResult: 'Master/PharmacyResult',
  medicationLabCheck:'LabResults/MedicationLabCheck',
  CompositAllergies: 'Master/CompositAllergies',
  address: 'Patient/PatientAddress',

  patientEmployer: 'Common/Employer',

  paymentType: 'Master/paymenttype',
  physicianProfile: 'Physicians/Physician',
  userProfile: 'Physicians/Profile',
  physicianProfileImage: 'Physicians/Photo',

// PayerCodes
  PayerCodes: 'Master/PayerCodes',
  PatientPaymentInfo: 'Patient/PatientPaymentInfo',

  createInsuranceBranch: 'Master/InsuranceInfo',
  deleteInsuranceBranch: 'Master/InsuranceBranch',


  createPatient: 'Patient/PatientInfo',
  createParent: 'Patient/ParentInfo',
  createGuarantor: 'Patient/GuarantorInfo',
  createNextOfKin: 'Patient/NextOfKinInfo',
  getPatientVisitCount:'Patient/PatientVisitCount',
  createEmergencyInfo: 'Patient/EmergencyInfo',
  patientRelationType:'Patient/PatientRelationShip',
  patientSpouse:'Patient/SpouceDetails',
  patientGuardian:'Patient/GuardianDetails',
  createPrimaryInsuranceInfo: 'Patient/PrimaryInsuranceInfo',
  InsuranceInfo: 'Patient/InsuranceInfo',
  InsuranceTypeChange:'Patient/InsuranceTypeChange',
  createCreditCardInfo: 'Patient/PaymentInfo',
  DocumentInfo: 'Patient/DocumentInfo',
  PhotoInfo: 'Patient/PhotoInfo',
  PaymentInfo: 'Patient/PaymentInfo',
  LocalPatient: 'Patient/LocalPatient',
  SecondaryInsuranceInfo: 'Patient/SecondaryInsuranceInfo',
  PrimaryInsuranceInfo: 'Patient/PrimaryInsuranceInfo',
  DeletePatientInsurance: 'Patient/DeletePatientInsurance',
  Physicians: 'Patient/Physicians',
  PatientReferingDoctors: 'Patient/PatientReferingDoctors',
  DischargeReasons: 'Patient/DischargeReasons',
  BedStatusDistinctReports: 'Patient/BedStatusDistinctReports',
  PatientViewNew: 'Patient/PatientViewNew',
  PatientCCI: 'Patient/PatientCCI',
  MSTCCI: 'Patient/MSTCCI',
  ERMSTCCI: 'ERDashBoard/PatientCCI',
  PatientNurseNotesPerformedDates: 'Patient/PatientNurseNotesPerformedDates',
 GenderIdentity:'Patient/GenderIdentity',
 SexualOrientation:'Patient/SexualOrientation',
 phoneNumberType:'Patient/PhoneTypes',
 occupatioType:'Common/BasicOccupations',
 basicOccupationsIndustry:'Common/BasicOccupationsIndustry',
 savepatient:'Patient/PatientInformation',
 patient_npi_search:'Patient/PhysicianNPISearch',
 cmrcDepartments:'Master/CRMC_Department',
 jobTitle:'Master/JobTitles',
  profileImage: 'Patient/ProfileImages',
  //Discharge

  //isDischargeMedications:'TrnMedications/IsDischargeMedications',
  // patientDDI:'Medications/PatientDDI',
  // dischargeInstructions:'ERDashBoard/DischargeInstructions',
  // nutritionActivity:'Discharge/NutritionActivity',
  // mstDischargeItems:'Discharge/MstDischargeItems',
  // dischargeIsDischargeMedications:'Discharge/IsDischargeMedications',

  dischargeinstructions: 'Discharge/Dischargeinstructions',

  //VitalSigns

  AllMSTReferenceRangeChartsAgeLimits: 'VitalSigns/AllMST_Reference_Range_Charts_Age_Limits',
  ProblemsLists: 'VitalSigns/ProblemsLists',
  SpecimenDiseaseTests: 'VitalSigns/SpecimenDiseaseTests',
  PatientVitalSignsByPatientIdVisitId: 'VitalSigns/PatientVitalSignsByPatientIdVisitId',
  PatientVitalSigns: 'VitalSigns/PatientVitalSigns',
  PatientResultsInfo: 'VitalSigns/PatientResultsInfo',
  PatientVitalSignsByPatientId: 'VitalSigns/PatientVitalSignsByPatientId',
  vitalSignDates: 'VitalSigns/VitalSignDates',
  vitalSignGroups:'VitalSigns/GroupVitalSignsUnitsNamesById',
  PatientVitalSignsByPatientIdDate: 'VitalSigns/PatientVitalSignsByPatientIdDate',
  existingVitalsPagination:'VitalSigns/PatientVitalSignsUnitsNamesById_V1',
  vitalsPdf:'Reports/PatientVitalsReport',
  // VitalSigns:'VitalSigns/VitalSigns',//post

  PatientPharmacies: 'Patient/PatientPharmacies',
  BCMAReports: 'Reports/BCMAReports',
  RegistrationTypes: 'Patient/RegistrationTypes',
  NursesEmergencyLocations: 'Patient/NursesEmergencyLocations',
  LocationPatient: 'LocationPatient',//LocationPatient?PatientID=7740&LocationID=1
  patientDocument: 'Patient/PatientDocuments',
  Photos: 'Patient/Photos',
  ActivateInactivateUser: 'Common/ActivateInactivateUser',
  //History
  HistoryController: 'History',
  historyPatientDisability: 'History/PatientDisability',
  PresentIllnessByPatientID: `History/PresentIllnessByPatientID`,
  PastMedicalHistoryByPatientID: `History/PastMedicalHistoryByPatientID`,
  pastMedicalHistoryUpdate:'History/PastMedicalHistory',
  FamilyHistoryByPatientID: `History/FamilyHistoryByPatientID`,
  SmokingHistoryByPatientID: `History/SmokingHistoryByPatientID`,
  MSHistoryByPatientID: `History/MSHistoryByPatientID`,
  ObstetricalHistoryByPatientID: `History/ObstetricalHistoryByPatientID`,
  deleteObstetricalHistory: 'History/TrnObstetricalHistory',
  MenstrualHistoryByPatientID: `History/MenstrualHistoryByPatientID`,
  SocialHistoryByPatientID: `History/SocialHistoryByPatientID`,
  PatientAllergies: `History/PatientAllergies`,//post
  deleteAllergies: 'History/DeletePatientAllergies',
  allergiesCategory:'Medications/AllergyIntoleranceCategories',
  allergiesIntolerance:'Medications/AllergyIntolerances',
  PatientMaritalHistory: 'History/PatientMaritalHistory',
  PatientObstetricalHistory: 'History/PatientObstetricalHistory',
  PatientMenstrualHistory: 'History/PatientMenstrualHistory',
  PatientSocialHistory: 'History/PatientSocialHistory',
  PatientPresentIllness: 'History/PatientPresentIllness',
  PatientPastMedicalHistory: 'History/PatientPastMedicalHistory',
  PatientFamilyHistory: 'History/PatientFamilyHistory',
  SocialHistoryByType: 'History/SocialHistoryByType',
  PatientNoneHistory: 'History/PatientNoneHistory',
  CreatePastSurgicalHistory: 'PastSurgicalHistory/PastSurgicalHistory',

  PastSurgicalHistory: 'PastSurgicalHistory/PastSurgicalHistory',
  MedicationSource: 'Medications/MedicationSource',
  FamilyHistoryStatus: 'History/FamilyHistoryStatus',
  getVisitLocation:'Patient/VisitLocation',
  getVisitCharges:'Patient/VisitCharges',
  getVisitInfo:'Patient/PatientVisit',
  alcohol:'History/Alcohols',
  violence:'History/Violence',
   //  CreateVisit: 'Patient/CreateVisit', 
   CreateVisit:'Patient/VisitInfo',
  DichargeLocation: 'Discharge/DischargeLocation',
  PatientInsurance: 'PatientInsurance',

  //family-history Updated
  FamilyMemberStatus: 'History/FamilyMemberStatus',
  FamilyHistoryProblems: 'History/FamilyHistoryProblems',
  FamilyHistory: 'History/FamilyHistory',
  FamilyHistoryMembers: 'History/FamilyHistoryMembers',
  PatientLatestROSPHETempateId: 'Template/PatientLatestROSPHETempateId',
  //CareTeam
  CareTeam: 'ERDashboard/CareTeam',
  //ClinicalTrial
  TRNClinicalTrial: 'ClinicalTrail/TRNClinicalTrail',
  PatientComponentData: 'Template/PatientComponentData',
  clinicaltrial: 'ClinicalTrail/ClinicalTrail',//post,delete

  cancelVisit: 'ERDashBoard/CancelVisit',
  moveToPending: 'ERDashboard/MoveToPending',
  moveToCurrent: 'ERDashBoard/MoveTocurrent',
  GetPatientAllergies: 'Patient/PatientAllergies',
  reactionData:'Patient/AllergyReactions',
  // GetPatientNote: 'Patient/PatientNotes',
  // PatientNote: 'Patient/PatientNote',
  // DeletePatientNotes: 'Patient/DeletePatientNotes',
  patients: 'Patient/Patients',
  NewPatientDashboard:'Patient/NewPatientDashboard',
  patient: 'Patient/Patient',
  allPatients: 'Patient/AllPatientSearch',
  locationPatients: 'Patient/ALLPatientsViewSearch',//create visit and add Patient search service changed by kranthi given by phani sir
  patientinfo: 'Patient/Patientinfo',
  fileupload: 'Patient/PhotoInfo',
  getphotoInfo: 'Patient/Photos',
  photoDownload: 'Patient/PhotoInformation',
  //Problems
  problems: 'Problems/Problems',
  Procedures:'Problems/Procedures',
  problemType: 'Problems/ProblemTypes',
  problemStatus: 'Problems/ProblemStatus',
  problemCode: 'Problems/ProblemCodes',
  problemGet: 'Patient/ProblemsListByPatientId',//get
  problem: 'Patient/ProblemsList',//post,delete
  panelDuplicate:'Problems/CheckPanelStatus',

  NDCBarCode:'Medications/NDCBarCode',
  CheckNDCBarCode:'Medications/CheckNDCBarCode',

  ICUForms: 'Template/ICUForms',
  DuplicateMedication: 'TrnMedications/DuplicateMedication',
  baseUrl1: 'http://192.168.20.67/emrweb',
  //codes types
  CPTCodes: 'Problems/CPTCodes',
  LonicCodes: 'Problems/LonicCodes',
  radLonicCodes: 'Problems/RadLoincCodes',
  ICDCodes: 'Problems/ICDCodes',
  SnomedCT: 'Problems/SnomedCT',
  snomedCTV1: 'Problems/SnomedCTV1',
  snomedCTVOBSValue: 'LabResults/GetObservationValue',
  observationMethodLABResult: "LabResults/GetObservationMethod",
  labResultLinkOrder:'LabResults/GetPatientLabOrders',
  customPanel:'Problems/CustomLoincPanel',
  //Medications
  drug: 'TrnMedications/PharmacyDrug',
  checkDuplicateMedication:'TrnMedications/CheckDuplicatePresentMeds',
  wsdrug: 'Medications/WSDrugs', //service change by veera prasad sir for phymarcy drug //http://192.168.20.79/falconapi/Medications/WSDrugs?drug=para
  route: 'Medications/Route',//http://192.168.20.79/falconapi/Medications/Route
  frequency: 'Medications/Frequency',//http://192.168.20.79/falconapi/Medications/Frequency
  frequencyIv:'TrnMedications/IvFrequencies',
  dosage: 'Medications/Dosage',//http://192.168.20.79/falconapi/Medications/Dosage
  Medications: 'TrnMedications/Medications',
  PresentMedications: 'TrnMedications/PresentMedications',
  vaccinationLotType:'Medications/VaccineLots',
  female_PregnancyStatus:'TrnMedications/PregnancyStatus',
  //GetERDashboard
  GetERDashboard: 'ERDashboard/GetERDashboard',
  ERDashboard: 'ERDashboard/ERDashboard',
  ERDashboardSplit:'ERDashBoard/ERDashboardSplit',
  ChiefComplaint: 'ERDashboard/ChiefComplaint',
  AttendingPhysician: 'ERDashboard/AttendingPhysician',
 MedicationReconcileStatus:'TrnMedications/MedicationReconcileStatus',
  generalComments: 'ERDashboard/GeneralComments',
  erDashboardNPPAType: 'ERDashBoard/MSTCareTeam',
  erDashboardNPPA: 'ERDashBoard/StaffCareTeam',
  erDashboardMD: 'ERDashboard/PhyCareTeam',
  physician: 'Physicians/MstPhysician',
  searchBed:"ERDashBoard/ERDashboardPatientBedSearch",
  //ordersets
  OrderSets: 'OrderSets/OrderSets',
  OrderSetBySetId: 'OrderSets/OrderSetBySetId',
  OrderSetByVisitId: 'OrderSets/OrderSetByVisitId',
  orderSetItem: 'Ordersets/OrderSetItem',
  orderSetMedItem: 'Ordersets/OrderSetMedItem',
  LabOrderFreQuency:'Master/LabOrderFreQuency',

  ADTOrder: 'OrderSets/ADTOrders',

  //Role
  roledata: 'Role/Roles',
  SaveRole: 'Role/UserRole',
  PrevoiusNurse: 'Patient/EmergencyPrevoiusNurse',//get
  nurseSave: 'Patient/EmergencyPatients',//save
  // PatientPharmacies:'Patient/PatientPharmacies',
  //ordersetsheading
  StartTypes: 'LabOrder/StartTypes',
  Frequency: 'LabOrder/Frequency',
  Priority: 'LabOrder/Priority',
  StartModes: 'LabOrder/StartModes',
  OrderTypes: 'LabResults/SpecimenSourceCode',
  SampleCollectedBy: 'LabOrder/SampleCollectedBy',
  OrderStatus: 'LabOrder/OrderStatus',
  CurrentMedicationsStatus:'TrnMedications/CurrentMediStatus',
  DosageForm: 'medications/DosageForm',
  Refill: 'medications/Refill',
  PA: 'TrnMedications/PACode',
  Qualifier: 'TrnMedications/Qualifier',
  DrugType: 'TrnMedications/DrugType',
  Diagnosis: 'TrnMedications/Diagnosis',
  UOMUnits: 'medications/UOMUnits',
  OrderSetMedications: 'OrderSets/OrderSetMedications',
  OrderSetMedications_custom: 'OrderSets/OrderSetMedications_V1',
  OrderSetCategories: 'OrderSets/OrderSetCategories',
  LabOrder: 'OrderSets/LabOrder',
  OrderSetActivity: 'OrderSets/OrderSetActivity',
  orderNameDuplicateCheck:'OrderSets/CheckOrderSetHeadingName',
  // patientOrderSet: 'OrderSets/PatientOrderset',  // present its not used changed by ramu,kondaiah
  patientOrderSet: 'OrderSets/PatientOrderset_V1',
  medicationOrderType:'TrnMedications/OrderType',
 respiratoryOrdersNames: 'OrderSets/RespiratoryOrders',
 patientRespiratoryOrders:'OrderSets/PatientRespiratoryOrders',
  respiratoryTypes:'OrderSets/RespiratoryType',
  customizationRespiratoryOrder :'OrderSets/MSTRespiratoryOrder',
  cardiovascularChargeCodes:'Master/CardiovascularChargeCodes',
  duration:'TrnMedications/DurationType',
  OrderSetDistinctCategories: 'OrderSets/OrderSetDistinctCategories',
  ActivityHeadingsItems: 'OrderSets/ActivityHeadingsItems',
  MedicationHeadingsItems: 'OrderSets/MedicationHeadingsItems',
  confirmOrderStatus: 'OrderSets/OrderStatus',
  // CustomOrderSet: 'OrderSets/CustomOrderSetNew',
  CustomOrderSet: 'OrderSets/CustomOrderSetNew_V1',
  PatientOrderInfoNotes: 'OrderSets/PatientOrderInfoNotes',
  Hl7V3: 'Master/Hl7V3',
  Activity: 'Medications/Activity',
  FavoriteOrderSet: 'OrderSets/FavoriteOrderSet',
  favouriteOrders: 'OrderSets/FavoriteOrder',
  ordersQueue: 'Ordersets/OrderApprovalQueue',
  ordersApprovalCloser: 'Ordersets/OrderApproval',
  ManageOrderActivityHeadingsItems: 'OrderSets/ManageOrderActivityHeadingsItems',
  ManageOrderMedicationHeadingsItems: 'OrderSets/ManageOrderMedicationHeadingsItems',
  PBMHistoryMedications:'TrnMedications/PBMHistoryResponse',
  TestPanel:'OrderSets/TestPanelComponents',
  MergeOrder:'OrderSets/MergeOrder',

  Menu: 'Menus/Menu',
  AssigningOrders: 'OrderSets/AssigningOrders',
  CustomComponent: 'Template/CustomComponent',
  CustomComp: 'Template/CustomComp',

  // mapResources :'Scheduler/MAPUserResource',
  mapedUserResource : 'Scheduler/MAPUserResource',
 mstResourceOrders :'Scheduler/MstResourceOrders',
  // For Change password
  changePassword: 'Login/ChangePassword',
  Procedure: 'Scheduler/AppointmentProcedures',
  Appointment: 'Scheduler/Appointments',
  outPatientSearchScheduler:'Patient/AdvanceOutPatientSearch',
  ResourceDetails: 'Scheduler/ResourceDetails',
  ScheduleBlockedDays: 'Scheduler/ScheduleBlockedDays',
  //ResourcePreference: 'Scheduler/ResourcePreferencesByResourceIds',
  ResourcePreference: 'Scheduler/ResourcePreferencesByResources',
    resourceImagingTypes:'LabOrder/ResourceImagingTypes',
  RefferalPhysician: 'Physicians/RefferalPhysician',
  downloadAppointments:'Scheduler/DownloadAppointments',
  AppointmentsByPatientId: 'Scheduler/AppointmentsByPatientId',
  PatientAdvancedSearchDetails: 'Scheduler/PatientAdvancedSearchDetails',
  TemplateComponent: 'Template/TemplateComponent',
  AllDocNurTemplates: 'Template/AllDocNurTemplates',
  AllPatientDocNurTemplates: 'Template/AllPatientDocNurTemplates',
  MstDocNusTemplateView: 'Template/MstDocNusTemplateView',
  scanDocuments:'Patient/FalconScanDocument',
  // for physican by staffId
  Staff: 'Staff/PhysicianById',
  locations: 'Staff/LocationsByStaffId',
  physicians: 'physicians/AllPhysician',
  staff: 'Staff/Staff',
  LocationById: 'Staff/LocationById',
  MstDocNusTemplate: 'Template/MstDocNusTemplate',
  newPhysicians: 'Physicians/Physician',
  MapedNursingStation:'NurseActions/MapNurseStation',
  nursingLocations:'Common/NursingStationLocations',
 existLocationsInNurseStations: 'Common/NursingStationLocations',
  UserPageSettings:'Common/UserPageSettings',
  MenuItems:'Common/MenuItems',
  SaveUserPageSettings:'Common/UserPageSettings',
  //location
  location: 'Location/NewLocation',
  locationsByUserId: 'Location/LocationsByUser',
  procedureBaseLocation1: 'Location/Procedure',
  duplicatelocation: 'Location/LocationDuplicate',
  Stafflocation: 'Staff/Location',
  deleteMstProcedure: 'Location/MstProcedure',
  postMstProcedure: 'Location/MstProcedure',
  opNurseStations:'Location/OPLocation',

  // NurseSearch:'Staff/PhysicianSearch',
  NurseDashboardSearch:'Staff/NurseDashBoardPatientByNstation',
  AllDepartment: 'Physicians/Department',
  DoctorType: 'Physicians/DoctorType',
  Telecommusecode: 'Physicians/Telecommusecode',
  TelecommEquipType: 'Physicians/TelecommEquipType',
  PhysicianLocation: 'Physicians/PhysicianLocation',
  PhysicianMapLocation: 'Physicians/PhysicianMapLocation',
  busySlot: 'Scheduler/BusySlots',
  resourceAvailability: 'Scheduler/ResourceAvailability',
  physicalResource: 'Scheduler/PhysicalResources',
  staffGrop: 'Scheduler/ResourceStaff',
  PatientDetails: 'Scheduler/PatientDetails',
  ReccurringAppointments: 'Scheduler/RecurringAppointment',
  Role: 'Role/Roles',
  allDepartment: 'Staff/GetDepartments',
  AddNewStaff: 'Staff/Insertuserandstaff',
  ChangePin:'Common/ChangeUserPin',
  // sevarity:'Physicians/Severity',
  Department: 'Staff/GetstaffDepartment',
  Severity: 'Physicians/Severity',
  procedureDuplicate: 'Scheduler/ProcedureDuplicate',
  Allprocedures: 'Scheduler/ProceduresResources',
  StaffSearch: 'Staff/Staff',
  schedulerCodeTypes: 'Scheduler/ProcedureTypes ',
  masterLocal: 'Scheduler/CodedProcedure',
  MstDocNusTemplatePatient: 'Template/MstDocNusTemplatePatient',
  AllDepartments: 'Physicians/Department',
  MapLocation: 'Staff/LocationsByStaffId',
  // AllLocation:'Staff/GetStaffLocationsByStatus',
  PhysicianDepartment: 'Physicians/UserDepartment',
  ServiceLevel: 'Physicians/ServiceLevel',
  Specialty: 'Physicians/Specialty',
  //Physician registration
  CheckUserId: 'Physicians/CheckUserId',
  ResetPassword: 'Physicians/ResetPassword',
  PersonalDetails: 'Physicians/PersonalDetails',
  ProviderInfo: 'Physicians/ProviderInfo',
  StateProvider: 'Physicians/StateProvider',
  PhoneNoBusiness: 'Physicians/PhoneNoBusiness',
  PhysicianScheduling: 'Physicians/PhysicianScheduling',
  PhysicianDepartments: 'Physicians/PhysicianDepartment',
  PhysicianDocuments: 'Physicians/PhysicianDocuments',
  MapPhysician: 'Staff/PhysiciansInfo',
  AllPhysicianInfo: 'Staff/PhysicianSearch',
  supervisingDoctor:'Staff/SuperVisingDoctors',
  supervisingMapMidPhy:'Staff/MapMidPhysician',
  supervisingMidPhysician:'Staff/MidPhysiciansInfo',
  supervisingMapPhysicianDle:'Staff/MapSupervisingDoctor',
  addEditProcedure: 'Scheduler/Procedure',
  PhysicianMapLocations: 'Physicians/PhysicianMapLocations',
  PhysicianMapDeparments: 'Physicians/PhysicianMapDeparments',
  PhysicianDocument: 'Physicians/PhysicianDocument',
  UserMapLocation: 'Physicians/UserMapLocation',//common service for both physicain and staff, get locations in preferences
  UserProfile: 'Physicians/UserProfile',//common service for both physicain and staff, get profileInfo in preferences
  MapPatTempData: 'Template/MapPatTempData',
  GetTemplateHtmlData: 'Template/GetTemplateHtmlData',
  // MapPhysician:'Staff/PhysicianSearch',
  // AllPhysicianInfo:'Staff/PhysiciansInfo',
  InsertNewStaff: 'Staff/InsertNewStaff',
  SaveOtherInfoDetails: 'Staff/StaffOtherInfo',
  SaveScheduling: 'Staff/InsertSchResource',
  SaveLocation: 'Staff/Insertmaplocation',
  SaveDepartment: 'Staff/InsertMapUserDept',
  SavePhysician: 'Staff/InsertMapPhysician',
  SaveServiceLevel: 'Staff/StaffServiceLevel',
  NewStaffInfo: 'Staff/GetStaffs',
  // Servicelevel: 'Staff/GetServicelevel', // Presently moved to  Physicians/ServiceLevel
  DeleteLocation: 'Staff/StaffLocation',
  DeleteDepartment: 'Staff/StaffDepartment',
  DeletePhysician: 'Staff/StaffPhysician',
  staffImage:'Staff/Photo',
  procedureLocation: 'Scheduler/ProceduresLocations',
  schedulerSearch: 'Scheduler/SearchPatientSchedules',
  resourceStaff: 'Scheduler/ResourceStaff',
  ResourcePreferences: 'Physicians/ResourcePreferences',
  HoldPreferences: 'Physicians/HoldPreferences',
  physicianImage:'Physicians/Photo',
  // nurseAction
  ExistingRecords: 'NurseActions/ExistingTreatments',
  orderSetByVisitId: 'NurseActions/OrderSetByVisitId',
  resources: 'Scheduler/BusySlotResources',
  ScheduleBlockReasons: 'Scheduler/ScheduleBlockReasons',
  WaitingList: 'Scheduler/WaitingList',
  AppointmentCancelReasons: 'Scheduler/AppointmentCancelReasons',
  PrintSchedules: 'Scheduler/PrintSchedules',
  rescheduleReasons: 'Scheduler/RescheduleReasons',
  GetTemplateTypes: 'Template/GetTemplateTypes',
  GetTemplateCategory: 'Template/GetTemplateCategory',
  GetForms: 'Template/GetForms',
  rescheduleAppointments: 'Scheduler/RescheduleAppointments',
  NotGivenReason: 'NurseActions/NotGivenReason',
  SaveNotGivenReason: 'NurseActions/NotGivenReason',
  Witness: 'TrnMedications/UsersByUserNameAndUserId',
  LoginPassword: 'Login/Validate',
  SaveActivity: 'NurseActions/Treatment',
  SaveLabRadiology: 'NurseActions/PatientResultsInfo',
  saveAuditData: 'Audit/ActivityLog',
  MSTTemplateGroup: 'Template/MST_TemplateGroup',
  MST_TemplateGroups: 'Template/MST_TemplateGroups',
  CheckTemplateName: 'Template/CheckTemplateName',
  CheckGroupName: 'Template/CheckGroupName',
  MSTTemplateCategory: 'Template/MSTTemplateCategory',
  MSTTemplateType: 'Template/MSTTemplateType',
  Templatetype: 'Template/Templatetype',
  TemplateCategory: 'Template/TemplateCategory',
  Mst_TemplateGroupDel: 'Template/Mst_TemplateGroupDel',
  TemplateData: 'Template/TemplateData',
  //rosOrgans:'ROSTemplate/ROSOrgans',
  rosOrgans: 'ROSTemplate/MstOrgan',     //Coment bye Kondaiah  ROS Image upload
  rosOrgans_V1: 'ROSTemplate/MstOrgan_V1',
  subOrgans: 'ROSTemplate/SubOrgansAndSubSymptomsByOrganId',
  organLocations: 'ROSTemplate/OrganLocations',
  rosTemplate: 'ROSTemplate/ROSTemplate',
  pheTemplate: 'PHE/PHETemplate',
  rosTemplateData: 'ROSTemplate/ROSTemplatesByID',
  // rosSubOrgans: 'ROSTemplate/ROSSubOrgansByVisitIdTemplateIdOrganId',
  rosSubOrgans: 'ROSTemplate/ROSSubOrgansAndSubSymptomsByOrganId',
  pheSubOrgans: 'PHE/PHESubOrgansAndSubSymptomsByOrganId',
  patientPheSubOrgans: 'PHE/PatientPHESubOrganByVisitIdTemplateId',
  patientRosSubOrgans: 'ROSTemplate/ROSSubOrgansByVisitIdTemplateIdOrganId',
  patientRosTemOrgansAndSubOrgans: 'ROSTemplate/PatientROSTemplatesByTempIdOrgId',
  patientPheTemOrgansAndSubOrgans: 'PHE/PatientPHETemplatesByTempIdOrgId',
  pheTemplateData: 'PHE/PHETemplatesByID',
  patientPHETemplateData: 'PHE/PatientPHETemplatesByID',
  rosOrganbytemplateId: 'ROSTemplate/ROSOrgan',
  rosTemplateGender: 'ROSTemplate/Gender',
  organSymptoms: 'ROSTemplate/Symptons',
  // findOrgan:'/ROSTemplate/OrganDuplicate',
  //rosTemplateNewOrgan:'ROSTemplate/Organ',
  TrnPatientTemplateGroupItems: 'Template/TrnPatientTemplateGroupItems',
  rosTemplateNew: 'ROSTemplate/NewTemplate',
  rosTemplateNew_V1 :'ROSTemplate/NewTemplate_V1',  //Ros Template Save after image kondaiah
  pheTemplateNew: 'PHE/NewTemplate', // PHE Template save after image 
  PatientROSTemplate:'ROSTemplate/PatientROSTemplate',
  pheTemplateNew_V1: 'PHE/NewTemplate_V1',
  rosByVisitId: 'ROSTemplate/ROSByVisitId',
  ReviewOfSystem: 'ROSTemplate/PatientROS',
  physicalExamination: 'PHE/PHEOrganByVisitIdTemplateId',
  TemplateNamesByVisitid: 'ROSTemplate/TemplateNamesByVisitid',
  PHETemplateNamesByVisitid: 'PHE/PHETemplateNamesByVisitid',
  PHETemplateByPhysicianID: 'PHE/PHETemplateByPhysicianID',
  patientPheTemplate:'PHE/PatientPHE',
  MstTemplateAutoText: 'Template/MstTemplateAutoText',
  Globalautotext: 'Template/Globalautotext',
  CheckAutoTextName: 'Template/CheckAutoTextName',
  PhysicianAutoText: 'Template/PhysicianAutoText',
  PHETemplateDuplicate: 'PHE/PHETemplateDuplicate',
  DeleteOrganSymptons: 'ROSTemplate/OrganSymptons',
  Mst_CustomCompGroup: 'Template/Mst_CustomCompGroup',
  CustomGroup: 'Template/CustomGroup',
  PatientROSTemplatesByID: 'ROSTemplate/PatientROSTemplatesByID',
  TrnPains: 'Template/TrnPains',
  MstPainQuality: 'Template/MstPainQuality',
  CheckIcuFlowItemType: 'Template/CheckIcuFlowItemType',
  MSTICUFlowchartItemTypes: 'ICU/MSTICUFlowchartItemTypes',
  MAPICUFLowChartItem: 'ICU/MAPICUFLowChartItem',
  IcuFlowChart: 'ICU/IcuFlowChart',
  JsonData: 'Template/JsonData',
  Mst_IcuControlFlowChartItem: 'ICU/Mst_IcuControlFlowChartItem',
  MstICUControl: 'ICU/MstICUControl',
  mstTimeSlots: 'ERDashBoard/TemplateFrequency',
  patTimeSlots: 'Template/PatTempFrequency',
  ICuSectionComponent: 'Template/ICuSectionComponent',
  PatientComponent: 'Template/PatientComponent',
  MstVitalSites: 'VitalSigns/MstVitalSites',
  MapVitalSite: 'VitalSigns/MapVitalSite',
  mstheartRhythm: 'VitalSigns/MstHeartRhythm',
  mstDeliveryDevice: 'VitalSigns/MSTVitalDeliveryDevice',
  mstBreathingPattern: 'VitalSigns/MSTBreathingPattern',
  AllCategoryHeadingsItems: 'OrderSets/AllCategoryHeadingsItems',
  templateCategory:'Template/DeleteTemplateCategory',
  // PatientTypes:'http://192.168.20.79/falconapi/Master/PatientTypes',
  // PatientStatus:'http://192.168.20.79/falconapi/Master/PatientStatus',
  // PatientAdmisionSource:'http://192.168.20.79/falconapi/Master/PatientAdmisionSource',
  // PatientAccomodation:'http://192.168.20.79/falconapi/Master/PatientAccomodation',
  // HosptialServiceType:'http://192.168.20.79/falconapi/Master/HosptialServiceType',
  // PatientArrivedby:'http://192.168.20.79/falconapi/Master/PatientArrivedby',
  changeResendPassword:'Physicians/ResendPassword',
  // ag-grid-custom-columns
  customsColumns: 'ERDashBoard/CustomColumns',
  //#region vital sign 
  VitalsSign: 'VitalSigns/VitalSign',                               //customization get 
  handOffNotes:'ERDashBoard/PatientNotesByUserId',
  medicationList:'ERDashBoard/TodayMedication',
  VitalUnits: 'VitalSigns/VitalUnits',
  duplicateVital: 'VitalSigns/CheckVitalSign',
  duplicateUnit: 'VitalSigns/CheckUnitName',
  VitalunitGetdata: 'VitalSigns/VitalUnitsById',                   ///edit for vital sign unit 
  VitalsignGetdata: 'VitalSigns/VitalsignId',                      ///edit for vital sign 
  UnitDraginvital: 'VitalSigns/VitalSignUnit',                     //drag and unit element and save
  // PatientVitalSave:'VitalSigns/PatientVitalSign',                 // vital saving in patient side
   patientVitalLog:'VitalSigns/PatientVitalSignLog',  
  VitalUnit: 'VitalSigns/VitalUnit',
  PatientVital: 'VitalSigns/PatientVitalSign',
  patientVitalSignDetails:'VitalSigns/PatientVitalSigns',                        //PatientVitalSignsUnitsNames
  MstIcuControls: 'ICU/MstIcuControls',
  ExistingVitalDetail: 'VitalSigns/PatientVitalSignsUnitsNamesById',   //Existing Patient Vital 
  // GetVitalDate: 'VitalSigns/VitalSignDates',                    //patient vital patch tha values base on date

  vitalPainSite: 'VitalSigns/PainSite',
  vitalPainQuality: 'VitalSigns/PainQuality',
  vitalSignRanges: 'VitalSigns/VitalSignRanges',
  //#endregion vital sign
  //MAR
  MarDetails: 'NurseActions/TrnMar',
  totalAndUnreadMARMessagesCount: 'Messages/TotalAndUnreadMARMessagesCount',

  OrganDuplicate: 'ROSTemplate/OrganDuplicate',
  ROSTemplateDuplicate: 'ROSTemplate/ROSTemplateDuplicate',
  OverDue:'NurseActions/OverdueMarCount',

  // summaryDashboard
  summaryDashboard: 'Patient/SummaryDashboardItems',
  assignbed:'ERDashBoard/ERDashboardPatientAssign',
  // pending orders
  pendingOrders: 'Patient/PatientPendingOrderByPatientId',


  // message
  messageInfo: 'Patient/MessagesByPatientId',
  chatInfo: 'Patient/ChatMessagesByPatientId',
  patientDetailsForMessaging: 'Messages/PatientDetailsForMessaging',
  messagesCount:'Messages/GroupChatNotificationCount',
  // summary patientInfo
  summaryPatientInfo: 'Patient/SummaryPatientInfo',

  // physicial examinations
  physicialExaminations: 'PHE/PhysicialExamination',

  // summary orders
  summaryOrder: 'Patient/SummaryDashBoardOrdersByPatientId',

  // Drug to Drug Allergies
  //drugToDrug: 'Medications/PatientDDI',
  //drugToFood: 'Medications/PatientDAI',
  trnMedicationsDrugToDrug: 'TrnMedications/PatientDDI',
  trnMedicationsDrugToFood: 'TrnMedications/PatientDAI',
  PatDDIDAI: 'TrnMedications/PatDDIDAI',
  DrugToDrugMonograph: 'MedicationInteraction/DrugToDrugMonograph',
  // Current Medications
  // currentMedications: 'TrnMedications/Medications',
  MedicationData: 'TrnMedications/TRNMedications',
  //Drug to Drug Interactions
  drugToDrugInteractions: 'TrnMedications/DDIWithPenToPen',
  // Drug to Allergies
  drugToAllergies: 'TrnMedications/DAIWithPenToPen',
  // No Medications Given
  noMedications: 'TrnMedications/NoGivenMedications',
  DDIDAI: 'TrnMedications/DDIDAI',
  DDIDAIRXNorm:'TrnMedications/DDIDAIRXNorm',
  // Eligibility Check
  originalPatient: 'TrnMedications/OriginalMedEligiBilityPatients',
  eligibilityPatient: 'TrnMedications/PatientEligiBilityPBMResponse',
  patientAllDetils: 'TrnMedications/PatientEligiBilityResponse',
  otherPharmacyDetails: 'TrnMedications/PatientEligiBilitySpecialityResponse',
  formularyBenifit: 'TrnMedications/FormularyBenifits',
  // Current-Medications Print
  printCurrentMedications: 'Reports/CurrentMedicationsReport',
  dischargeMedicationPrint: 'Reports/DischargeMedicationsReport',
  // Medications History
  medicationsHistory: 'TrnMedications/MedicationHistoryResponse',
  // Clinical Reconciliation
  patientProblems:'Common/ProblemsReconcilitionList',
  patientAllergies:'Common/PatientReconcilitionAllergies',
  ccdaPatientRequest:'Patient/MSTPatientRequests',
  reconciliationStatusLog:'TrnMedications/MedicationReconcilelog',
  // procedure
  procedure: 'Patient/Procedures',
  //summary Print
  patientSummaryPrint: 'Reports/PatientVisitTotalSummaryReport',

  printDischargeInstructionsReport: 'Reports/PrintDischargeInstructionsReport',

  // laboratories
  laboratories: 'Patient/DashBoardLabResult',

  // Group templates

  groupTemplates: 'Template/Trn_PatientTemplateGroup',

  CheckCustomName: 'Template/CheckCustomName',
  GetLayOuts: 'Template/GetLayOuts',
  //Amendments
  patientAmendments: 'Patient/PatientAmendment',
  getSource: 'Patient/AmendmentSource',
  getRequestedBy: 'Patient/PatientAmendmentAutoText',
  // saveAmendment: 'Patient/PatientAmendment',
  getPatientNotes: 'Patient/Trn_PatientNote',
  // savePatientNotes: 'Patient/Trn_PatientNote',
  getCode: 'Master/Hl7V3',
  //Mar
  Route: 'Medications/Route',
  Diluent: 'TrnMedications/Diluent',
  notGivenReason: 'TrnMedications/NotGivenReason',
  notGivenAndPRNReasons:'Common/PRNGivenAndMedHoldAndMedRefuseReasons',
  SaveDiluent: 'TrnMedications/Diluent',
  Volume: 'Medications/VolumeUnits',
  MarAdverse: 'TrnMedications/MedAdverse',
  PatientAllergy: 'Master/CompositAllergies',
  Intolerance: 'TrnMedications/MedIntolerance',
  checkMedicationDup: 'Medications/CheckDiluent',
  SaveMar: 'NurseActions/TRNMAR',
  MarImage: 'Patient/PatientImage',
  intakeNote: 'Template/TrnNurseNoteIntake',
  intakeMethod: 'Template/MstNurseNoteIntakeMethods',
  TrnNurseNoteOutputdata: 'Template/TrnNurseNoteOutputdata',
  TrnNurseNoteIntakedata: 'Template/TrnNurseNoteIntakedata',
  TrnMedicationIntakeOutput: 'TrnMedications/IntakeOutput',
  duplicateInOutItemMnemonic:'IntakeOutput/DuplicateInOutItemMnemonic',
  WSDrugsRoute: 'Medications/WSDrugsRoute',
  IVConnectedLine: 'TrnMedications/IVConnectedLine',
  outputField: 'Template/MstNurseNoteOutput',
  intakeOutput: 'Template/TrnNurseNoteIntakeOutput',
  output: 'Template/TrnNurseNoteOutput',
  shift: 'Template/Shifts',
  site: 'Template/IntakeSite',
  IVSite: 'Peripheral/IVSite',
  IVTypes: 'TrnMedications/IVTypes',
  patientInsurenceEligibility:'TrnMedications/PatientEligibility',
  intakeOutputCalculation: 'Template/TrnInOutShiftTotal',
  typeOfFluid: 'Template/Fulid',
  checkIntakeOutputMethod: 'Template/CheckIntakemethod',
  checkIntakeOutputSite: 'Template/CheckSite',
  checkIntakeOutputHeaderNames: 'Template/Checkoutput',
  // get the mar note details
  MarNoteData: 'TrnMedications/TRNMarAllNote',
  TRNMAR: 'TrnMedications/TRNMAR',
  // post and Delete Mar Note Details
  MarNoteDetails: 'TrnMedications/TRNMarNote',
  CancelMedication: 'TrnMedications/DischargeMedicationReasons',
  marAdminDetails:'NurseActions/MarAdministrationDetails',
  // get the recent note details
  // RecentNoteData:'TrnMedications/Primarynote',
  OverDueMedicationsData: 'TrnMedications/MedicationOverDue',
  // mar note details viewed by other staff..
  notedetailsviewbyotherstaff: 'TrnMedications/TRNMarNotestatus',

  dischargeMedications:'Reports/DischargedMedicationsReport',
dischargeVitals:'Reports/DischargedVitalsReport',
  marStatus: 'NurseActions/MARStatus', //get
  // Hold the all the medications in Mar
  marHold: 'TrnMedications/MARHold',

  // Linked Medications get
  ConnectedMedications: 'TrnMedications/LinkedOrdersMeds',
  DeleteChildLinkedMedications:'TrnMedications/DelLinkMedOrders',
  CurrentMedicationsForLinkedMedications:'TrnMedications/LinkedMedicationOrders',
  DeleteParentMedications:'TrnMedications/DelMedicationRowId',
  // educatonal resource
  existingrecord: 'EducationResources/DownloadPatientEDUDoc',
  problemsearch: 'EducationResources/SearchPatientEdu',
  // getProblemList:'EducationResources/PatientEDUDocId',
  getProblemList: 'EducationResources/TRnProblemList',
  crmcDocDel:'EducationResources/DeleteCrmcDocumentsBasedonId',
  saveMail: 'Common/SendEmail',
  saveEduDocument: 'EducationResources/TrnPatientEduDoc',
  Problem: 'EducationResources/GetRFMLINM0_ICD9CMNAME',
  getDocumentLink:'EducationResources/MstEduResourceLinks',
  getDocument: 'EducationResources/TrnPatientEdudoc',
  categories:'EducationResources/GetEducationCategories',
  subCategories:'EducationResources/GetEduCategoriedById',
  edurResources:'EducationResources/GetEducationResource',
  resourceById:'EducationResources/GetEduDocByResourceId',
  resourceByLink:'EducationResources/GetEduLinksByResourceId',
   documents:'EducationResources/MstEduResourceDocuments',
   patientEduDocSav:'EducationResources/MSt_EduResourceDocuments',
   category:'EducationResources/InsertCategories',
   categoriesIds:'EducationResources/GetPathBasedonCategoryIds',
   DocumentsLinksDel:'EducationResources/PathBasedonId',
   resourceDetails:'EducationResources/GetResourceDetails',
   comprehensive:'EducationResources/EDUComprehensionLevels',
   readIness:'EducationResources/ReadinessToLearn',
   patientExiDocuments:'EducationResources/GetDocumentNames',
   patientExistingDocData:'EducationResources/Gettrainingpatientdetailsbyid',
   eduProblemSearch:'EducationResources/GetSnomedCTNamesInSearch',
   patientTrainingDetails:'EducationResources/DeletePatientTraingingDetails',
   delCategory:'EducationResources/DeleteCategoriesBasedOnCategoryId',
   delResources:'EducationResources/DeleteResourcesBasedOnIds',
  //Care Plan
  carePlan: 'Patient/CarePlan',
  deletecarePlan: 'Patient/CarePlans',
  carePlanPriority: 'Master/GoalPriority',
  carePlanIntent: 'Master/CarePlanIntent',
  carePlanRequestStatus: 'Master/CarePlanRequestStatus',
  carePlanReferalReasonSearch:'Master/CCDAValueSetSearch',
  //Refill Request
  reFillrequestBySPI: 'RefillRequests/ReFillrequestBySPI',
  dispenseApproved: 'RefillRequests/DispenseApproved',
  denialReasonCodes: 'RefillRequests/DenialReasonCodes',
  searchRefillRequest: 'RefillRequests/SearchRefillRequest',
  medicationByPhysicanId: 'RefillRequests/MedicationByPhysicanId',
  refillXmlParsing: 'RefillRequests/RefillXmlParsing',
  problemTypeCodes: 'Problems/ProblemTypeCodes',
  updateRefillReq: 'RefillRequests/updateRefillReq',
  deletePhysician: 'ERDashBoard/CareTeam',
  deleteNurse: 'ERDashBoard/CareTeamNurse',
  refillRequestPrint: 'Reports/RefillRequestReport',
  //scheduler Receptionist login services
userResourceAppointments:'Scheduler/UserAppointments',

  AllResources: 'Scheduler/AllResources',
  ResourceDetailsByName: 'Scheduler/ResourceDetailsByName',
  PhysicianDetails: 'Scheduler/PhysicianDetails',
  presentMedicationStatus: 'TrnMedications/PresentMedicationStatus',
  dischargeSignOutList: 'Discharge/DischargeSignOutList',
  checkOut :'Discharge/CheckOut',
  signOut: 'Discharge/SignOut',
  dischargeMessage:'Discharge/DischargeMessage',
  signOutData:'Discharge/SignOutDetails',
  dischargeCheckOut: 'Discharge/DischargeCheckOut',
  checkVisit: 'Scheduler/CheckVisit',
  //Messages Module Services
  importantMessage: 'Messages/ImportantMessage',
  MessageComposeTypes: 'Messages/MessageComposeTypes',
  MessageCategories: 'Messages/MessageCategories',
  MessageTypes: 'Messages/MessageTypes',
  MessageSourceTypes: 'Messages/MessageSourceTypes',
  MessageSource: 'Messages/MessageSource',
  UsersDetailsForMessaging: 'Messages/UsersDetailsForMessaging',
  MsgCategoriesAndSubCategories: 'Messages/MsgCategoriesAndSubCategories',
  UserMessages: 'Messages/UserMessages',
  MessageInfo: 'Messages/MessageInfo',
  MessageSettingsDefinedForUser: 'Messages/MessageSettingsDefinedForUser',
  MessageOtherSettingsForUser: 'Messages/MessageOtherSettingsForUser',
  totalAndUnreadMessagesCount: 'Messages/TotalAndUnreadMessagesCount',
  MessageReadStatus: 'Messages/MessageReadStatus',
  UsersDetailsForReply: 'Messages/UsersDetailsForReply',
  UserSentMessages: 'Messages/UserSentMessages',
  UserMessage: 'Messages/UserMessage',
  UserNotifications: 'Messages/UserNotifications',
  NotificationCount: 'Messages/NotificationCount',
  NotificationStatus: 'Messages/NotificationStatus',
  MedicationNotificationsCount: 'OrderSets/MedicationNotificationsCount',
  OrdersetNotificationsCount: 'OrderSets/OrdersetNotificationsCount',
  OrdersetNotifications: 'OrderSets/OrdersetNotifications',
  MedicationNotifications: 'TrnMedications/MedicationNotifications',
  marMessagesSearchList: 'Messages/MessagesSearchList',
  rolesBySearchParam: 'Role/RolesBySearchParam',
  adminUsers: 'Menus/MstUsers',
  userMenus: 'Menus/TrnMenuUsers',
  groupMenus: 'Menus/Groups',
  groupMenuUsers: 'Menus/GroupMenu',
  allGroupMenu:'Menus/AllGroupMenu',
  physicianMenu:'Menus/PhysicianMenu',
  defaultPhysicianMenus:'Menus/PhysicianDefaultMenu',
  groupName: 'Menus/CheckGroupMenuName',
  patientMarMessages: 'Messages/PatientMarMessages',
  // assign permission
  allFunctions: 'AssignPermission/MstFunctions',
  functionView: 'AssignPermission/MstFunctionViews',
  modulesByUser: 'AssignPermission/FunctionByUserID',
  checkFunction: 'AssignPermission/FunctionName',
  assignPermissionUsers: 'AssignPermission/UserRoleId',
  userType: 'AssignPermission/UserTypes',
  userRole: 'AssignPermission/UserRole',
  pageAction: 'AssignPermission/MstUserFunctionRole',
  AssignPermission:'AssignPermission/UserTypesAndRoles',
  trnFunctionAssign: 'AssignPermission/TrnFunctionAssign',
  roleBasedPermissionsAssign: 'Menus/RoleWiseAssignPermission',

  moduleWiseFunction: 'AssignPermission/ModuleWiseFunctions',
  medicationReconcile:'TrnMedications/MedicationReconcile',

  //uploads
  checkDuplicateServiceType:'Patient/CheckDocTypeName',
  PatientUploadDocType: 'Patient/PatientUploadDocType',
  messageCategories:'Messages/UserMessageSettings',
  locationBasedUser:'Staff/UsersByLocationId',
  // patient arrival
  patientArrival: 'Patient/PatientArrival',
  patientArrivalStatus: 'Patient/PatientArrivalStatus',
  //Procedures
  usernamesByRoleId:'Template/UsersByRoleIdLocationId',
  trnProceduresReasonsId: 'Patient/TrnProceduresReasonsId',
  trnProceduresMedReasons: 'Patient/TrnProceduresMedReasons',
  tRNProcedures: 'Patient/TRNProcedures',
  searchProcedureName: 'Patient/SearchProcedureName',
  procedureCurrentstatus: 'Patient/ProblemCurrentstatus',
  //procedureCurrentstatus:'Patient/ProdurceCurrentstatus',
  reasonTypes: 'Patient/ReasonTypes',
  searchReasonName: 'Patient/SearchReasonName',
  trnprocedureNames: 'Patient/TrnprocedureNames',
  ProcedureReasonforUpdate: 'Patient/ProcedureReasonforUpdate',
  getDepartmentsStartswith: 'Common/GetDepartmentsStartswith',
  //physician home in er-dashboard 
  patientDiseaseCount: 'ERDashBoard/PatientDiseaseCount',
  Clinics: 'Master/Clinics',
  erPatientList: 'ERDashBoard/PatientsList',
  getPatientTodayYesterday: 'ERDashBoard/PatientsCounts',
  getPatientWeekltList: 'ERDashBoard/WeeklyPatients',
  patientArrivalTime: 'ERDashBoard/PatientArrived',
  patientTriageCount: 'ERDashBoard/PatientsTriageCount',
  bedInformation:'ERDashBoard/BedInformation',
  tooltipDataErDashboard:'TrnMedications/PopUpMedications',
  erdashboardTidColorCodes:'ERDashBoard/TidColorCode',
  erdashboardCriticalConditions:'ERDashboard/CriticalConditions',

  //HL7 generation
  labName: 'HL7/HL7LaboratoryLocation',
  HL7Interface: 'HL7/HL7Interface',
  HL7OrderControl: 'HL7/HL7OrderControl',
  HL7Verson: 'HL7/HL7Version',
  HL7ContextBased: 'HL7/HL7ContextBased',
  ViewHL7: 'HL7/ViewHL7Files',
  HL7Orders: 'HL7/HL7LabOrders',
  HL7Results: 'HL7/HL7LabResults',
  GenerateHL7: 'HL7/GenerateHl7',
  Hl7ReportableLab:'HL7/HL7ReportableLab',
  GenerateHl7ForReportableLab:'HL7/GetHL7ReportableLabs',
  //  GenerateHL7ORM:'HL7/GenerateLabOrdersHL7r',
  GenerateHL7ORM: 'HL7/ReadLabResultsORUR01',
  // GenerateORU: 'HL7/ReadLabResultsORUR01',
  // Medication-reconciliation
  medicationreconciliation: 'TrnMedications/MedicationStatus',
  reconcilMedications: 'TrnMedications/ReconcilMedication',
  folwRateUnits: 'TrnMedications/FlowRateUnits',
  //AuditLogReports
  activityType: 'AuditReport/LogActivities',
  moduleType: 'AuditReport/ModuleReports',
  logReports: 'AuditReport/LogReports',
  userName: 'AuditReport/AuditUserName',
  auditTable: 'AuditReport/AuditTable',
  auditOrginalTableData: 'AuditReport/EffectedTable',
  // Advance Directives
  AdvanceDirectivesStatus: 'Patient/GetMstAdvancecodeStatus',
  AdvanceDirectivesName: 'Patient/GetMstAdvanceName',
  AdvanceDirectives: 'Patient/MstAdvanceDirective',
  // Consents
  consents: 'Patient/TrnPatientContentsDoc',
  problemSearch: 'Patient/GetRFMLINM0_ICD9CM_NAME',
  searchConsents: 'Patient/GetMSTConsentStartsWith',
  consentsWithPatientId: 'Patient/GetPatientContents',
  deleteConsentsProblems: 'Patient/TrnPatientContentsDocId',
  deleteAllConsents: 'Patient/DeleteTrnPatientconsent',
  // lab reportable information
  searchcode:'Patient/MstLabReportCode',
  patientlabreports:'Patient/MstReportableLabs',
  searchlabcode_name:'Patient/GetLonicNamesbyCode',
  relevantClinicalInformation:'Master/RelevantClinicalInformation',
  codingSystem_HL7:'Master/CodingSystem_HL7',
  labObservationReport:'LabResults/LabObservationsResult',
  sourceOfComments:'Master/SourceOfComment',
  commentTypes:'Master/CommentType',
  // Error Message starts

  mapIVMeds: 'NurseActions/TRNMapIVMeds',

  relationOfPatientStatus: 'Patient/PatientRelationStatus',

  inPatientDashboard: 'Inpatient/IPDashBoard',

  outPatientDashboard: 'OutPatient/OPDashboard',
  updateArrivalDateTime:'Patient/UpdateArrival',
  roomCurrentPosition: 'Common/CurrentPosition',
  outPatientCurrentPosition: 'OutPatient/PatientCurPosition',
  outPatientCurrentDepartment: 'OutPatient/PatCurDepartment',

  patientMedicalStatus: 'EmergencyAccess/PatientMedicalStatus',

  previewClinicalSummary: 'Patient/PreviewClinicalSummary',
  clinicalSummaryGeneration: 'Patient/ClinicalSummary_v1',
  clinicalSummaryGenerationValidation:'Patient/ValidationStatusMultiPat',
  previousXMls: 'Patient/PreviousXml',
  previousXMLPreview: 'Patient/PreviewClinicalSummaryXml',
  // customizeClinicalSummary: 'Patient/Customize', // old one replaced with `customizeClinicalSummary`.
  customizeClinicalSummary: 'Patient/CustomizeClinicalSummary_v1', // new one.
  mutliClinicalSummaryStatus: 'ClinicalSummaryCollection/GetClinicalSummaryCount',
  clinicalSummaryTrasmit: 'Patient/Transmit',
  clinicalSummaryDownloadXML: 'Patient/DownloadXMLData',
  clinicalSummaryDecline: 'Patient/Decline',
  clinicalSummaryCSPath: 'Patient/ClinicalSummaryByPatientId',
  clinicalSummaryEncryptType: 'Patient/EncryptionTypes',
  clinicalSummaryCancel: 'Patient/Cancel',
  clinicalSummaryCustomize: 'Patient/CustomizeClinicalSummary',
  PatientTemplateReport:'Reports/PatientTemplateReportByJsonData',

  // social psychological behavioral
  financialResourceStrain:'History/FinancialResourceStrain',
  loincAnswerList:'History/LoincAnswerList',
  education:'History/Education',
  stress:'History/Stress',
  depression:'History/Depression',
  physicalActivity:'History/PhysicalActivity',
  connectionIsolation :'History/ConnectionIsolation',
  allLoincAnswerListQuestion:'History/LoincAnswerQueList',
  //nurse monitoring
  nurseMonitoring:'Common/MstEmergencyPatients',
  nurseBasedOnPhysician:'Patient/EmergencyNurseNames',
  activityLogOut:'Login/LogOut',
  nurseSelection:'InPatient/TrnStaffCareTeam',
  hospitalization:'History/PastHospitalizationHistory',
  checkHospitalization:'History/CheckPastHospitalHistory',
  //#region lab result
  labResultLaboratoryLocations: 'LabResults/LaboratoryLocations',
  labResultMedicalDirectorDetails: 'LabResults/MedicalDirectorDetails',
  labResultVisitAllPatientSearch:'LabResults/VisitAllPatientSearch',
  labResultPrincipalResultInterpreter: 'LabResults/PrincipalResultInterpreter',
  labResultReferenceRangeChartsAgeLimit: 'LabResults/ReferenceRangeChartsAgeLimit',
  labResultReferenceRangeCharts: 'LabResults/ReferenceRangeCharts',
  labResultPatientOrderTimingQuantity: 'LabResults/PatientOrderTimingQuantity',
  labResultPanelData: 'LabResults/PanelData',
  labResultPanelSearchParams: 'LabResults/PanelSearchParams',
  labResultLabCategories: 'LabResults/LabCategories',
  labResultHL7V3: 'LabResults/HL7V3',
  labBasicSpecimen: 'LabResults/BasicSpecimenDetails',
  labResultValueType: 'Master/HL7ValueTypesV1', //SR1
  labResultHealthCareUnits: 'Master/HealthcareUnits',
  labResultAbnormalFlag: 'Master/AbnormalflagsV1', //SR1
  labResultResultStatus: 'LabResults/HLObservationResultStatus',
  labOrderInfo: 'LabResults/LabOrderInfo',
  labResultInfo: 'LabResults/LabResultsInfo_V1',
  volumeUnits:'Medications/DiluentUnit',
  labResultPatientOrderSpecimen: 'LabResults/PatientOrderSpecimen',
  labResultPatientLabResultInfo: 'LabResults/PatientLabResultInfo',
  labOrderSpecimenCheck: 'LabResults/PatientLabOrderSpecimenCheck',
  labAdvancedSpecimenDetails: 'LabResults/AdvancedSpecimenDetails',
  labSpecimenSite: 'LabResults/SpecimenSites',
  labOrderInfoTreeView: 'LabResults/LabOrderInfoTreeView',
  LabOrderCategories: 'LabResults/LabOrderCategories',
  labResultReport: 'Reports/LabResultsReport',
  labResultImage: 'LabResults/LabResultImages',
  labResultResultNote: 'LabResults/PatientOrderResultNote',
  LabResult:'LabResults/LabResult',
  ReportableLabCodes:'Reports/ReportableLabCodes',
  PatientRadiologyResultInfo:'Radiology/PatientRadiologyResultInfo',
  RadiologytReport:'Reports/PatientRadiologyResultsReport',
  RadiologyOrderReport:'Reports/PrintRadiology',
  RespiratoryOrderReport:'Reports/RespiratoryOrderReport',
  CardiovascularOrderReport:'Reports/CardiovascularOrderReport',
  PrintConsultOrderReport:'Reports/PrintConsult',
  PrintRehabOrderReport:'Reports/PrintRehab',
  

  rehabAndCardioWorklist: 'LabResults/RehabAndCardioWorklist',
  //#endregion

//MasterHL7Code
masterHL7V3SpecimenRole:'Master/SpecimenRole',
masterHL7V3SpecimenRejectReason:'Master/SpecimenRejectReason',
masterHL7V3SpecimenAdditiveOrPreservative:'Master/SpecimenAdditiveOrPreservative',
typeOfComments:'Master/CommentType',
specimenCondition:'Master/SpecimenCondition',
masterOrderStatus:'Master/OrderStatus',
//MasterHL7Code

  // Nurse Dashboard
  nurseShifts:'Staff/GetMstShift',
  nurseTimings:'Staff/InsertTrnNurseDuty',
  nursePatientRelationShip:'Common/GetNursePatRelations',
  patientList:'Common/AssignedFloorDepartmentBeds',
  patientDetails:'Staff/InsertMapNursepatDaily',
  patientDetailsNurseDashBoard:'Staff/GetNurseDashBoard',
  nurseShiftChecking:'Staff/CheckNurseShiftTimings',
  nursePatientSearch:'Staff/NursePatientsAssigningSearch',
  nurseShiftIds:'Staff/NurseShiftTimmings',
  otherPatientDetails:'Patient/NurseAllDashBoardPatients',
  nurseActions:'NurseActions/NurseDashboardType',
  physicianSelection:'Patient/PhysicianMyList',
  deletePatient:'Patient/MapNursePatDaily',
  marDetails:'NurseActions/NurseDashboardMar',
  Actions:'NurseActions/NurseDashboardNurseActions',
  patientlistAllDashboards:'Patient/NurseERPatients',
  previousPatients:'Common/NursePreviousPats',
  dashboardlist:'Common/PatientTypes',

  physicianInformation: 'ERDashboard/PhysicianInformation',

  radiologyImpression: 'LabResults/PatientRadiologyImpression',
  radImpression: 'LabResults/PatientRadImpression',
  MarMedications:'NurseActions/MarMedications',

  // menus
  menuRole: 'Menus/CheckRollName',
  roleMenu: 'Menus/RoleMenus',
  roleSubMenu: 'Menus/RoleSubMenus',

  //#region patient-charts (or)template charts
  // scanTemplateFolders:'Patient/MstScanFolders', // it is not using for patient module
  patientChartsForTree:'Patient/PatientChartsForTree',
  patientChartDoc:'Patient/PatientCharts',
  patientChartUpdate:'Patient/UpdatePatientChartsByIds',
  patientCharts:'Patient/PatientChart',
  movePatientCharts :'Patient/MovePatientCharts',
  patientChartExternalFile: 'Patient/PatientExternalFiles',
  patientChartExternalPreview: 'Patient/PreviewPatientChart',
  patientChartExternalFileDownload: 'Patient/DownloadPatientCharts',
  //scanDocuments:'Patient/FalconScanDocument',
  //#endregion

  //EDU-Resource
  eduResourceXmlData:'HealthInformation/HealthInfoFeed',
  //#region Care Plan
  healthConcern: 'Patient/CPHealthConcern',
  healthGoal: 'Patient/CPGoals',
  intervention: 'Patient/CPInterventions',
  patientOutCome:'Patient/CPOutCome',
  interventionMedLab: 'Patient/CPInterventionMEDLAB',
  revision: 'Patient/CPRevision',
  healthStatus: 'Patient/CPHealthStatus',
  healthConcernStatus: 'Patient/HealthConcernStatus',
  //#endregion

//Group Resources
groupNamesByLocationId:'Scheduler/GroupNamesByLocationId',
resourcesInGroupId:'Scheduler/ResourcesInGroupId',
groupResources:'Scheduler/GroupResources',
groupResourceStatus:'Scheduler/GroupResourceStatus',
groupNameStatus:'Scheduler/GroupNameStatus',
// physicial resourece
 physicalResourceData:'Scheduler/PhysicalResource',
 checkResorceName:'Scheduler/ResourceNameStatus',
//  physicalResourceSave:'Scheduler/PhysicalResource',
 PhysicalResourceStatus:'Scheduler/PhysicalResourceStatus',
 // general note 
 erGeneralNotes:'Patient/VisitNote',

  //sirisha staff login
  mstPainSites: 'Template/PainSites',
  checkPainSite: 'Template/CheckPainSiteName',
  userDashboardMenus: 'Menus/UserMenus',
  markasreview: 'ERDashboard/ReviewComponent',
  customgroup_element: 'Template/CustomCompGrp',
  downloadTemplate: 'Reports/DynamicTemplatesReport',
  MstCustomComponent: 'Template/MstCustomComponent',
  ActiveInactiveCustomGroup: 'Template/ActiveInactiveCustomGroup',
  InsertMapVitalSite: 'VitalSigns/InsertMapVitalSite',
  IVLinesWithDrugsByVisitId: 'TrnMedications/IVLinesWithDrugsByVisitId',
  skipLocation: false,
  // ResetPasswordwithtoken: 'Login/ResetPassword',
  ResetPasswordwithtoken: 'Login/ResetPassword_V1',
  appVersion: require('../../package.json').version,
  AllCodeStatus: 'CodeStatus/AllCodeStatus',
  AddNewCodeStatus: 'CodeStatus/AddNewCodeStatus',
  PatientCurrentWeight: 'VitalSigns/PatientCurrentWeight',
  allPatientComponents: 'Template/AllComponents',
  checkUnEsignedTemplateGroupForSignOut: 'Template/CheckUnEsignedTemplateGroupForSignOut',
  patientRelatedStaff:'Patient/PatientAssignedNurseAndPhysician',
  notifications: 'Notifications/Notifications',
  medicationNotificationData:'Notifications/UnReadMedications',
  roomManagerNotificationData:'Notifications/UnReadAdtOrders',
  notificationStatus:'Notifications/NotificationStatus',
  masterData:'Master/Master',
  vitalSigns_default:'VitalSigns/DefaultUnits',
  templateCounts:'Template/NotesMyNotesCount',
  discardTemplate:'Template/MapPatTempData',
  assignTemplates:'Template/MapDocnUstemplate',
  PatientTemplateCoSign:'Template/PatientTemplateCoSign',
  TemplateMaxPreviewSettings:'Template/TemplateMaxPreviewSettings',
  TemplateAddendum:'Template/TemplateAddendum',
  PatientInfoByVisitId:'Patient/PatientInfoByVisitId',
  MstRoles:'Template/MstRoles',
  PatientTemplateReportByJsonDataForMultiple:'Reports/PatientTemplateReportByJsonDataForMultiple',
  PatientRadiology:'Radiology/PatientRadiologyInfo',
  VerifyRadiology:'Radiology/VerifyRadiology',
  ClinicalRadiology:'Radiology/ClinicalRadiology',
  ImagingModifiers:'Master/ImagingModifiers',
   // Bed Management
  //  FloorNames:'Common/MstFloor',
   departmentsForBeds:'Common/Departments',
   getDepartmentsID:'History/Department',
   permanentDeleteBed:'Common/ParmentDelBedsInfo',
   permanentDeleteRoom:'Common/ParmentDelRoomInfo',
   permanentDeleteFloor:'Common/ParmentDelFloorInfo',
   permanentDeleteDepartment:'Common/ParmentDelDepartmentInfo',
   permanentDeleteMultiBeds:'Common/ParmentDelMultipleBeds',
   existingFloors:'Common/Floors',
   rooms:'Common/Rooms',
   floorRoomInBedAllotment:'ERDashBoard/FoorandRoomInformation',
  // floors:'Common/Floors',
   mstFloors:'Common/MstFloor',
   mstRooms:'Common/MstRoom',
   mstBeds:'Common/MstBeds',
   //roomNameStatus:'Common/RoomNameStatus',
   roomNameStatus:'Common/CheckRoomInNStation',
   mstBedStatus:'Common/MstBedStatus',
   floorNameStatus:'Common/FloorNameStatus',
   floorBedTree:'Common/FloorDepartmentBeds',
   floorsRoomsBed:'Common/FloorDepartmentBeds',
   floorDept:"Common/MapFloorDept",
   CheckDeptDuplicate:'Common/CheckNursingStationOnFloor',
   inActiveFloorsandBeds:'Common/InActiveFloors',
   duplicateBeds:'Common/CheckDuplicateBeds',
   roomType:'Common/RoomType',
   menuOrderStatus:'ERDashboard/PatientOrdersStatus',
   inActiveFloorByLocation:'Common/AllFloors',
   detaildBedView:'Common/RoomRelatedBeds',
  verifyRoomsInNurseStation:'Common/CheckNursingStationHaveRooms',
  roomAndBedInNurseStation:'Common/NursingstationDataWithBeds',
 patientListSummaryByNursingStationReport: 'Reports/PatientListSummaryByNursingStationReport',
 // moveRoomsAndBedsToanotherNUrsing:'Common/NursingStation',
 mapedNursingStationByLocation:'Common/MapLocationNursingStation',
  patientByNursingStations:'Staff/NurseDashBoardPatientByNstation',
  deleteNursingStation:'Common/DeleteNursingStation',
   mstACtiveDepartments:'Common/MstActiveFloor',
   changeStatusForAllBeds:'Common/ModifyBedStatus',
   NurseNoteLog:'Template/NurseNoteLog',
   TemplateActivityLog:'Template/TemplateActivityLog',
  inActivateAllBeds :'Common/InActiveBeds',
   cancelDischarge:'Discharge/CancelDischarge',
   checkPatientIsDischarge:'Patient/CheckPatientDischarge',
   ocuupiedBedCheck:'Common/BedCount',  
   previousVisit:'Patient/PreviousVisits',
   singlarChatUsers:'PushNotifications/AllUsersForChat',
   chatMessages:'Messages/ChatMessages',
   chatNotificationCount:'Messages/ChatNotificationCount',
   chatGroups:'Messages/ChatGroups',
   NurseNoteLogByComponentId:'Template/NurseNoteLogByComponentId',
   changeVisitPhysicians:'Patient/ChangeVisit',
   patientProblemVisit:'Patient/ProblemVisit',    //dropdown
   patientCommunicationType:'Patient/CommunicationType',
   getpatientProblemVisit:'Patient/ProblemVisit',   //for problemvisit
   patientCommunication:'Patient/PatientCommunication',
   deletenamegroupitem:'Patient/PatientNameTypesInfo?',
   patientCheckProblem:'Patient/CheckProblemName',
   resourceProcedure:'Scheduler/ResourcesProcedures',
   resourceByPhysicians:'Physicians/ResourcePrimaryDoctor',
   //nurse actions
   actionPerformedData:'NurseActions/ActionPerformedData',
  laboratoryPerformedData :'NurseActions/NurseActionOrders',
  checkUserName:'NurseActions/CheckActionUsers',

  TRNOrderSetItemId:'OrderSets/DeleteOrderByItemID',

//// Visit Merge
visitMergeMedications:'Patient/VisitMrgMedications',
visitMergeProblems:'Patient/VisitMrgProblemsList',
visitMergeAlleegies:'Patient/VisitMrgPatientAllergies',
mergePatientSearch:'Patient/VisitMergeSearch',
ActiveInactiveICUForm:'Template/ActiveInactiveICUForm',

// Receptionist
rolsAndGroups:'Scheduler/RolesAndGroups',
categoryTypesInScheduling:'Scheduler/CategoryTypes',
userBasedCategoryInScheduling:'Scheduler/UsersBasedOnCategory',
ActiveInactiveCustomComp:'Template/ActiveInactiveCustomComp',
ActiveInactiveROSTemplate:'ROSTemplate/ActiveInactiveROSTemplate',
ActiveInactivePHETemplate:'PHE/ActiveInactivePHETemplate',
importTemplates:'Template/ImportMstDocNusTemplate',
userProfilePhoto:'Common/UserProfilePhoto',
MAPICUFLowChartItem_V1:'ICU/MAPICUFLowChartItem_V1',
ImportCustomOrderSet:'OrderSets/ImportCustomOrderSet',
ImportROSTemplate:'ROSTemplate/ImportROSTemplate',
ImportPHETemplate:'PHE/ImportPHETemplate',
ActiveInactiveTemplate:'Template/ActiveInactiveTemplate',
MstProducts:'master/MstProducts',
trnImplants:'Common/TrnImplants',
ProductsCatalogue:'Master/ProductsCatalogue',
CheckProductsName:'Master/CheckProductsName',
checkImplantStatus:'Common/CheckImplantName',
//immunization
vaccination:'Immunization/AllVaccines_V1',
Addedvaccination:'Immunization/MSTVaccineLot',
manufactureImmunization: 'Immunization/MstMvxByCvxCode',
// vaccineTypes:'Immunization/VaccineTypes',
Allvaccinations:'Immunization/Vaccines',
showAllVaccineTypes:'Immunization/VaccineTypes',
addNewDepartments:'Common/FloorDept',
generateOtp:'Login/GenerateOTP',
verifyOtp:'Login/ValidateOTP',
verifyEmail:'Login/CheckValidateMail',
otpGeneration:'Login/ValidateEmail',
cvxCodes:'Common/CVXCodes',
//lab results view
labResultsData:'LabResults/PatLabResult',
labTreeRoot:'LabResults/PatLabDashBoard',
labDashboad:'LabResults/LabDashBoard',
labDates:'LabResults/PatientLabDates',
dayWisePatientLabResult:'LabResults/DayWisePatientLabResults',
// AdvancedPatientSearch
advancedPatientSearch:'Patient/AdvancePatientSearch',
reviewComponent:'ERDashboard/ReviewComponent',

  // #region Immunization
//vaccination:'Immunization/Vaccine',
vaccineTypes:'Immunization/AllActiveVaccineTypes',
vaccinations:'Immunization/AllActVaccines',
vaccineRoute:'Immunization/VaccineRoute',
immunizationSite:'Immunization/BodySiteValues',
addSite:'Immunization/BodySite',
checkImmunizationSite:"Immunization/CheckBodySite",
manufacturer:'Immunization/MstMvx',
eligibilityDesc:'Immunization/VFCEligibility',
reminderMethod:'Immunization/VaccineReminders',
immunizationRegStatus:'Immunization/ImmunizationRegistryStatus',
patientVaccination:'Immunization/VaccineInformation',
ActivityOrders:'OrderSets/PatientActivityOrders',
PatientDietOrders:'OrderSets/PatientDietOrders',
vaccinationNames:'Immunization/AllVaccines_V1',
HL7MessageImmunization:'Immunization/HL7Messages',
downloadAckMessageForImmunization:'Immunization/DownloadAckMessageForImmunization',
downloadHL7MessageImmunization:'Immunization/DownloadHL7Messages',
genAllHL7Immunization:'Immunization/GenAllHL7',
manufacturerData:'Immunization/MvxName',
checkManufactureName:'Immunization/CheckMvxName',
visDocumentType: 'Immunization/VISDocumentTypes',
deletedVaccineInformation: 'Immunization/DeletedVaccineInformation',
generateHL7MessageForDeletedVaccine: 'Immunization/GenerateHL7MessageForDeletedVaccine',
downloadHL7MessageForDeletedVaccine: 'Immunization/DownloadHL7MessageForDeletedVaccine',
hl7MessageAdminGroupTypesForImmunization: 'Immunization/HL7MessageAdminGroupTypesForImmunization',
immunizationHistoryFromNIST: 'Immunization/GetEvaluatedImmunizationHistoryFromNIST',
transmitHL7MessageForImmunization: 'Immunization/TransmitHL7MessageForImmunization',
importImmunization: 'Immunization/ImportHL7MessageForImmunization',
immunizationFundingSource: 'Immunization/FundingSourceListForImmunization',
  // #endregion Immunization
//#region Template Image Coord
templateImgNotePoints: 'Template/TemplateImgNotePoints',
//#endregion Template Image Coord
checkPainQuality:'Template/CheckPainQualityName',
dischargeToIp:'Physicians/DischargeToIp',
templateFlowsheet: 'Reports/PatientTemplateFlowsheetReportByJsonData',
rosPheOrganDdisplay:'ROSTemplate/OrganImageById',
nursingStation:'Common/NursingStation',    //dropdownget
checkNursingStation:'Common/CheckNursingStation',
nursingStationData:'Common/NursingStations',
checkDuplicateForVitals:'VitalSigns/CheckVitalSignMnemonic',
checkDulicateVaccineName:'Immunization/CheckVaccineName',
isolation:'Common/Isolations', // VR1
  roomsByNursingStations:'Common/NursingStationRoomsandBeds',
  //#region Technician Pharmacy
  patientsPharmacy: 'TrnMedications/patientview',
  cancelMedicationOrder: 'TrnMedications/CancelMedication',
  pharmacyMedicationCount: 'TrnMedications/TotalMedicationCount',
  vitalsIntial:'VitalSigns/InitialAndLatestVitalSigns',
  PatientsPharmacyMed:'TrnMedications/medicationview',
  pharmacyDispenseCategory:'TrnMedications/PharmaDispenseCategory',
  pharmacyDispenseLocation:'TrnMedications/PharmaDispenseLocation',
  pharmacyBillingFormula:'TrnMedications/PhamaBillingFormula',
  patientPendingMedication: 'TrnMedications/PatientPendingMedication',
  frequencyHours: 'TrnMedications/FrequencyHours', // deprecated.
  firstDoseTime: 'TrnMedications/FirstDoseTime', // deprecated.
  pharmacistFrequencyHours: 'TrnMedications/PharmacistFrequencyHours',
  totalDispenseDrug: 'TrnMedications/FrequencyTimmings',


  medicationLockAndUnLock:'UserScreenLock/UserPatWorkScreenLock',
  drugMedUnit: 'Master/DrugMedUnit',
  //#endregion Technician Pharmacy

  //#region Template Mnemonic duplicate check.
  checkTemplateMnemonic: 'Template/CheckTemplateMnemonic',
  OrderSetOrdersByHeadingId:'OrderSets/OrderSetOrdersByHeadingId',
  nurseStationVitals:'VitalSigns/MapVitalsNursingStations',
  visitBedDetails:'Patient/VisitBedNursingStation',
  //#endregion Template Mnemonic duplicate check.
//#region IV Medications
  diluentAmount:'Medications/LibraryDiluentAmount',
  diluentName:'Medications/DrugLibraryDiluent',
  diluentNames:'Medications/MST_Diluent',
  //#endregion IV Medications


  staffUser: 'Staff/users',
  InPatPharmacyDrugs:'Medications/InPatPharmacyDrugs',
  //http://192.168.20.107/falconapi/Medications/PharmacyDrugs?drug=dopam&drugType=IV

  inHousePharmacyDrugs:'TrnMedications/PharmacyDrug',
  MedicationHeadings_V1:'OrderSets/MedicationHeadings_V1',
  OrderSetByVisitId_V1:'OrderSets/OrderSetByVisitId_V1',
  OrderSetBySetId_V1:'OrderSets/OrderSetBySetId_V1',
  ConsultsPhysicians:'ordersets/ConsultsPhysicians',
  AllCategoryHeadingsItems_V1:'OrderSets/AllCategoryHeadingsItems_V1',
  GeneralInstructions:'Discharge/GeneralInstructions',
  DischargeNote:'Discharge/DischargeNote',
  CodesICDSMT:'Problems/CodesICDSMT',
  searchPhysicianNameSpeciality:'Patient/searchPhysicianNameSpeciality',
  DischargeInsJson:'Discharge/DischargeInsJson',
  OrderSetByVisitId_V2:'OrderSets/OrderSetByVisitId_V2',
  AssigningOrders_V1:'OrderSets/AssigningOrders_V1',
  checkIsSearialOrder:'Master/MedSerialOrders',

  //additives 
  additives:'TrnMedications/AdditiveMedications',
  // Drug Pharmacy
  DuplicatesCheck:'Medications/CheckMedicationDuplicate',
  PharmacyDrug:"Medications/PharmaDrugs",
  PharmacyDrugDetails:"Medications/MedicationDrugs",
  PharmacyDrugGetDetails:'TrnMedications/MedicationDrugs',
  medStatusCode:'Medications/MedStatusCode',
  DeaClassCodeUnits:'Medications/DeaClassCodeUnits',
  pharmaDrugUnits:'Medications/PharmaDrugUnits',
  PharmacyDrugInfo:'Medications/PharmaDrugLibraries',
  ExistingTreatments_V1:'NurseActions/ExistingTreatments_V1',
  pharmacyWeekOrders:'TrnMedications/MedOrdersCount',
  pharmacyDayOrders:'TrnMedications/GetDayMedOrders',
  lastOneDayPharmacyOrders:'TrnMedications/MedAllOrderList',

  //Barcodes
  generateBarcode:'TrnMedications/MedLabel&Print',
  forGotPassword:'Login/ForgotPassword',
  vitalSignGroup:'VitalSigns/VitalSignGroups',
  dragVitalSignGroup:'VitalSigns/GroupVitals',
  dragVitalSignGroupAndVitals:'VitalSigns/VitalSignGroupsAndVitals',
  checkVitalSignGroup:'VitalSigns/CheckVitalsignGroupName',
  nurseStationGroupVitalSigns:'VitalSigns/NursingStationGroupVitals',
  //#region Clinical Data Management
  rxChangeReqstBySPI: 'TrnMedications/RXChangeReqstBySPI',
  denyRxChange:'TrnMedications/UpdateRXChngReqst',
  AllRxChangeRequest:'TrnMedications/AllRXChangeRequests',
  rxChangePatientSearch:'TrnMedications/SearchRXChngReqst',
  rxChangeRequest:'TrnMedications/RXChangeReqst',
  clinicalDataManagement: 'TrnMedications/DrugItems',
  BillindDetails: 'Medications/DrugItems',
  cdmDrug: 'Medications/DrugManagmedicationSearch',
  cdmVendor: 'TrnMedications/MSTVendors',
  cdmDepartment: 'TrnMedications/ChargeDeparment',
  cdmSubDepartment: 'TrnMedications/ChargeSubDeparment',
  cdmRevenue: 'TrnMedications/MSTRevenue',
  cdmRoomType: 'Common/RoomType',
  cdmQuantity: 'TrnMedications/MstPackage',
  cdmCheckChargeCode: 'TrnMedications/CheckChargeCode',
  cdmCheckVendor: 'TrnMedications/CheckVendermnemonic',
  cdmCheckRevenue: 'TrnMedications/CheckRevenueMnemonic',
  cdmCheckDepartment: 'TrnMedications/CheckChargeDepartment',
  cdmCheckSubDepartment: 'TrnMedications/CheckSubDepartment',
  cdmReturnDrug: 'TrnMedications/ReturnDrugItem',
  cdmDamageDrug: 'TrnMedications/DamagedDrug',
  cdmDispenceDrug: 'TrnMedications/DrugDispence',
  barcodeType: 'TrnMedications/BarCodeType',
  printIVBarcode:'Images/GenerateIVLabelPdf',
  BarcodeUnableToScanReason: 'TrnMedications/BarcodeUnableToScanReason',
  countReturnDrug: 'TrnMedications/CountForReturnDrugs',
  captureConnectedPrinters:'Images/PrinterDetails',
  //#endregion Clinical Data Management
  //Pharmacy////
  duplicateDrugName:'Medications/CheckDrugStatus',
  VerifyUserPin:'Common/VerifyUserPin',
  MstIcuFlowChartItemsList:'ICU/MstIcuFlowChartItemsList',
  MstIcuFlowChartItemList:'ICU/MstIcuFlowChartItemList',
  CheckIcuFlowChartItem :'ICU/CheckIcuFlowChartItem',
 esiLevel :'ERDashboard/EsiLevelsData',
 esiLevels:'ERDashboard/EsiLevels',
 criticalCondition:'ERDashboard/PatCriticalConditions',
 criticalGroups:'ERDashboard/CriticalConditions',
 visitIsolation:'ERDashboard/VisitIsolation',
 beds:'Common/BedNamesByLocId',
  //#region intake-output
  intakeOutputCategory: 'IntakeOutput/IntakeOutputCategories',
  intakeOutputItem: 'IntakeOutput/IntakeOutputItems',
  intakeOutputItemCategory: 'IntakeOutput/IntakeOutputItemCategories',
  intakeItemCategories: 'IntakeOutput/IntakeItemCategories',
  outputItemCategories: 'IntakeOutput/OutputItemCategories',
  duplicateInOutCategoryMnemonic:'IntakeOutput/DuplicateInOutCategoryMnemonic',

  patientIntakeOutput: 'IntakeOutput/PatientIntakeOutput',
  patientIVIntake: 'IntakeOutput/PatientIVIntakeData',
  typeOFFluidDupCheck: 'IntakeOutput/CheckDuplicateFluid',
  ImagingTypes:'LabOrder/ImagingTypes',
  ImagingCodes:'LabOrder/ImagingCodes',
  PatientTransport:'OrderSets/PatientTransport',
  //#endregion intake-output
  checkVitalSign:'VitalSigns/CheckVitalSiteItems',
  checkChiefComplain:'ERDashboard/CheckChiefComplaint', //y1
  nurseCareTeamTypes:'Patient/NurseRoleByuserId', 
  roleBasedNurses:'Patient/UsersByRoleId',
  LabCollectFrom:'OrderSets/LabCollectFrom',
  LabCollectDateTimes:'OrderSets/LabCollectDateTimes',
  LabCollectSamples:'OrderSets/LabCollectSamples',
  Specimens:'Problems/Specimens',
  erpatientOrderLogs:'OrderSets/ErordersLog',
  patientAuditLog:'Patient/PatientData',
  locationStatus:'Location/LocationStatus',
  locationInactiveStatus:'Location/NewLocation',
  patientNoneHistory:'History/NoneHistory',
  marSetting:'TrnMedications/MARSettings',
  // stat with pharmacysetting
   pharmacySetting:'Common/PharmacyVerifySettings',
  //end with

  // Medical Orders
   patientOrderStatus:'OrderSets/PatientOrderStatus', // VR2,
  marSettings:'TrnMedications/MARSettings',
  // getMarSettings:'TrnMedications/MARSettings',
  TemplateAttest :'Template/TemplateAttest', //devi
  PatientReports:'Reports/PatientReports',//devi
  panelOrders:'Problems/PanelOrders' ,//SR1
  patientReportInfo:'Patient/PatientReportInfo',

  // group chat
  newgroupData:'Messages/UsersGroupChat',
  newgroup:'PushNotifications/UsersGroupChat',
  duplicateGroupNames:'Messages/CheckDuplicateChatGroup',
  groupChatMessages:'Messages/GroupChatMessages',
  groupMessagesCount:'Messages/GroupsUnReadCount',
  // start with SR1 Diet Orders
  deleteGroup:'Messages/InActiveGroup',
  levelOfCare:'Common/LevelOfCare',

  // CPOE patient-care
  ccdaCodeList_Consultaion:'Physicians/CCDACodeList_Consultaion',
  SubConsultData:'OrderSets/SubConsultData',
  ConsultData:'Physicians/CCDACodeList_Consultaion',
  patientCondition:'Patient/MSTPatientCondition',
  dietOrders:'OrderSets/DietOrders',
  dietCount:'OrderSets/DietOrdersCount',
  dayWiseDietCounts:'OrderSets/DietOrdersDateWiseCount',
  dietOrderNotifications:'PushNotifications/DietOrderNotificationCount',
  readAndUnReadDietOrders:'OrderSets/DietOrdersReadUnreadMsg',
  careplanCategory:'Master/CarePlanCategory',
  serviceRequestPriority:'Master/RequestPriority',
    // Room Manager all services
    bedsDayWiseCount:'ERDashBoard/BedsDayWiseCount',  
    displayBedsCount:'ERDashBoard/BedsCount',
    pendingPatient:'ERDashBoard/PendingPatients',
      // CPOE Orders
      deleteSelectedOrder:'OrderSets/OrdersetItemStatus',
      deleteOrderSetHeading:'OrderSets/OrdersetHeadingStatus',
    AllocatedPatients:'ERDashBoard/AllocatedBeds',
    pendingPatientGraph:'ERDashBoard/PatientBedCount',
    FamilyHistory_V1:'History/FamilyHistory_V1',
    removePatientFromBed:'ERDashBoard/UpdateBeds',
    PatientLevelOfCare:'OrderSets/LevelOfCare',
    dietNotificationData:'Notifications/DietOrderNotification',
aiLogin:'login',
    transcribe:'transcribe',
    transcribeConf:'transcribe/okhttp',
    // transcribeConf:'transcribe/chunks',
    taggedchunks:'clinicalscript/seacrch/taggedchunks',
    // check onec and note this error at ur side when required we will see    OMP: Error #15: Initializing libomp140.x86_64.dll, but found libiomp5md.dll already initialized.
// OMP: Hint This means that multiple copies of the OpenMP runtime have been linked into the program. That is dangerous, since it can degrade performance or cause incorrect
//  results. The best thing to do is to ensure that only a single OpenMP runtime is linked into the process,
//  e.g. by avoiding static linking of the OpenMP runtime in any library. As an unsafe, unsupported, undocumented workaround you can 
// set the environment variable KMP_DUPLICATE_LIB_OK=TRUE to allow the program to continue to execute, but that may cause crashes or silently produce incorrect results. 
// For more information, please see http://openmp.llvm.org/
    audioSegments:'clinicalscript/seacrch/audiosegments',
    tagroles :'clinicalscript/tagroles',
    generatedoc :'clinicalscript/generatedoc',
    generateStructuredDoc :'clinicalscript/generatedoc/json',
    docProblemsmerge:'clinicalscript/extractedinfo',
    AudioFile:'AudioFile/AudioFile',
    todayTaskList:'Physicians/PhyNurDailyTasks',
    taskOrder:'Physicians/TaskOrder',           
    checkTaskName:'Physicians/CheckTask',
    AudioDiscussion:'AudioFile/AudioDiscussion',
    updateSingleRecord:'AssignPermission/UpdateSingleRecord',
    // diet Orders Service
    formula:'Master/DietFormulaProduct',
    // user settings
    timeout:'Login/LogOutSetting',
    auditLock:'Patient/AuditStatus',
    // Auto measurementsREPORTS
    timelyAccessDetail:'History/TimelyAccessDetailsNew',
    amPatientEducationDetails :'History/AMPatientEducationDetails',
    amMedicationReconciliationDetails:'History/AMMedicationReconciliationDetails',
    amSummaryOfCare :'History/AMSummaryOfCare',
    amFamilyDetails :'History/AMFamilyDetails',
    amElectronicNotesDetails:'History/AMElectronicNotesDetailsNew',
    amAdvDirectivesDetails:'History/AMAdvDirectivesDetails',
    amLabTestEHToEPDetails :'History/AMLabTestEHToEPDetails',
    amEMarDetails:'History/AMEMarDetails',
    autoMeasuresCategories:'History/AutoMeasures',
    reportableLabsCategores:'Reports/ReportableLabs',
    reportableLabsDetails:'Reports/PatientLabReports',
    // AMmendement request
    ammendementRequest:'Patient/PatientDemographicAmendmentsCount',
    demograpicPatientInfo:'Patient/PatientDemographicAmendments',

   // checkPhysicianCellnumberandEmail:'Physicians/CheckPhyEmailandCellNumber',
    checkCellnumberandEmail:'Staff/CheckStaffEmailandCellNumber',

    // clinical-reconciliation 
    medicationGenericName:'TrnMedications/PresentMedications',
    reportableLabCount:'Patient/ReportLabActiveInactiveCounts',
   pqriGroup :'Master/MeasureGroup',

   // Display Patient Count using  Bar Chart 
   implantProductName:'Master/ImplantProductCodes',
   patientCounts:'ERDashBoard/PatientsVisit',
   // conversation SR1
   mergeConversation:'Common/MergeConversation',
   emergencyAccess:'Patient/PatientEmergencyAccess',

   implantDevice: 'https://accessgudid.nlm.nih.gov/api/v3/devices/lookup.json',

   InterventionEvaluation:'Patient/InterventionEvaluation',
   CarePlanGoals:'Patient/CarePlanGoals',
   ClinicalSummary_v1_K:'Patient/ClinicalSummary_v1_K',
   PatientAuditLog:'Reports/PatientAuditLog',
   ClinicalSummary_TOC:'Patient/ClinicalSummary_TOC',
   ClinicalSummaryFHIR_TOC:'HL7Fhir/PatientBundleResource',
  //  ClinicalSummaryFHIR_TOC:'Patient/ClinicalSummaryFHIR_TOC',
  medicationByMedRowId: 'TrnMedications/MedicationDataByMedicationRowId',
  CodedVitals:'VitalSigns/CodedVitals',
  QRDAImportFile:'QRDA/QRDAImportFile',
  DischargeInsActivityLog:'Discharge/DischargeInsActivityLog',
  QRDAMeasureNames:'QRDA/QRDAMeasureNames',
  CalculateMeasures:'QRDA/CalculateMeasures',
  QRDAPatientDetails:'QRDA/QRDAPatientDetails',
  PopulationDetails:'QRDA/PopulationDetails',
  CreateIsexpired:'Patient/DeathInfo',
  PostChargeMasterData:'TrnMedications/ChargeMaster',
   ImportFileChargeMaster:'TrnMedications/Importdata',
  GetChargeMasterData:'TrnMedications/ChargeMaster',
  DeleteDirectMails:'EMRDirectMail/EMRDeleteMails',
  GetDirectMessage:'EMRDirectMail/GetMailsByStatus',
  GetReciveMessage:'EMRDirectMail/ReceiveMail',
  GetStates:'EMRDirectMail/GetStates',
  GetSearchMail:'EMRDirectMail/Lookup',
  postDirectMessage:'EMRDirectMail/Sendmail',
  UpdateReadStatus:'EMRDirectMail/UpdateReadStatus',
  mailNotification:'EMRDirectMail/FolderCounts',
  GetRevenueCode:'Medications/RevenueCodes',
  granularRaces:'Master/GranularRaces',  
  granularEthnicity:'Master/GranularEthnicity',
   //integrity
 patientXmlEncriptedStatus:'Patient/patientXmlEncriptedStatus',
 previousXmlDataPreview:'Patient/ClinicalSummaryHTMLPreview',
 compareTwoXmlData:'patient/Comparefiles',
 //sydromic serveillance
 adtA04Registation:'HL7_ADT/ADT_A04',
 adtA08Update:'HL7_ADT/ADT_A08',
 adtA03Discharge:'HL7_ADT/ADT_A03',
 adtA01Admission:'HL7_ADT/ADT_A01',


 // Customization Care Team 
 masterValueSetOid:'Master/ValueSetOID',
admitTypes:'Patient/AdmitionType',
 customizationCareTeam:'CareTeam/CareTeamMaster',
 careTeamNumberRemove:'CareTeam/DeleteCareTeamMember',
 careTeamContactRemove:'CareTeam/DeleteCareTeamContact',

 //Er-dashboard Care Team 
 er_DashboardCareTeam:'CareTeam/CareTeam',
 allPhyCareTeamMembers:'CareTeam/CareTeamOnPhysician',

  //#region CDS-Alert ------------------------------------------------------------------------------
  cdsAlert: 'CDS/CDSAlerts',
  patientCDSCompleteData:'AICDSS/CDSSPatientData',
  patientCdsAlert: 'cds/GetCDSAlertsByPatientId',
  checkCdsRuleName: 'CDS/Check_RuleName',
  //#endregion CDS-Alert ---------------------------------------------------------------------------
  HTMLPreview:'Patient/HTMLPreview',
  Assessment :'Patient/Assessment',
  GenReportableLabHL7:'ReportableLab/GenReportableLabHL7',
  CDADownloadAndTransferStatus:'ClinicalSummaryCollection/CDADownloadAndTransferStatus',
  DecryptExternalFiles:'Patient/DecryptExternalFiles',
  GenerateQRDA1Xml:'QRDA/GenerateQRDA1Xml',
  QRDA1PreviewXml:'QRDA/QRDA1PreviewXml',
  GetReportableLabPatient:'ReportableLab/GetReportableLabPatient',
  GenReportableLabHL7ByOrderId:'ReportableLab/GenReportableLabHL7ByOrderId',
  DownloadXMLData_TOC:'Patient/DownloadXMLData_TOC',
  Transmit_TOC:'Patient/Transmit_TOC',
  DirectTransmit_TOC:'Patient/DirectTransmit_TOC',
  nwCorpcomposeRx:'TrnMedications/ComposeRx',
  DownloadHl7Message :'ReportableLab/DownloadHl7Message',

  diagnosisType: 'Master/MST_DiagnosisType',
 GenerateQRDA3Xml:'QRDA/GenerateQRDA3Xml',
 QRDA3PreviewXml:'QRDA/QRDA3PreviewXml',
 autoMeasuresReportingPeriod:'AutoMeasures/MeasureReports',
 autoMeasuresPrescribing:'AutoMeasures/Electronic_Prescribing',
 saveIsolation:'Patient/UpdateIsolation',
 codestatusIsolation:'Patient/GetIsolation_Codestatus',
 DietOrdersCodes :'Master/DietOrdersCodes',

 // #### NwCorp ####

 nwCorpFullMedicationHistory:'trnMedications/PatientFullMedicationHistory',
 nwCorpFullAllergies:'trnMedications/PatientAllergyHistory',
 nwCorpMedicationHistory:'TrnMedications/NewCropPatientMedHistory',
 completionStatus:'Immunization/RxCompleteStatus',
 EDProcedures:'Master/EDProcedures',
 EDClinicalImpression:'EDClinicalImpression/EDClinicalImpression',
 specialityList:'Master/Speciality',
 specialityData:'Physicians/MapUserSpeciality',
 PhysiciansBySpeciality:'Physicians/PhysiciansBySpeciality',
 AssessmentStatus:'Master/AssessmentStatus',
 ResultStatusV1:'Master/ResultStatusV1',
previousReasonData:'LabResults/LabOrderReasons',
DispositionType:'Discharge/DispositionType',
DischargeActivitys:'Discharge/DischargeActivitys',
DischargeDiet:'Discharge/DischargeDiet',
AllDispositions:'Discharge/AllDispositions',
cancelDisposition:'Discharge/CancelDisposition',
//Cancer -registries
grade:'Master/CancerGrades',
diagnosisConformation:'Master/CancerDiagnosisConformation',
behaviourGuide:'Master/CancerBehavior',
typeHistrology:'Master/ICD03CODES',
icd10Codes:'Master/ICD10Code',
stages:'Master/CancerStages',
metastasis:'Master/CancerTNMStages',
cancerRegistriesXml:'ReportableCancer/CancerRegistriesXML',
sites:'master/CancerSite',
cancerProblems:'ReportableCancer/ProblemsListByCancerPatient',
cancerRegistries:'ReportableCancer/PatientCancerStatus',
downloadCancerRegistries:'ReportableCancer/DownloadXMLData_Cancer',
// CRMC Validate
crmcValidate:'Login/CRMCValidate',
Disposition_Details:'Discharge/Disposition_Details',
UpdateEDClinicalImpressionOrder:'EDClinicalImpression/UpdateEDClinicalImpressionOrder',
ChiefComplaintDelete:'Template/ChiefComplaint',
tagrolesStructured:'clinicalscript/tagroles/structured',
DashboardMenus:'Menus/DashboardMenus',
verificationData:'Problems/ProblemVerificationTypes',
WTLeninfPercentile:'Common/WTLeninfPercentile',
BMIAgerevPercentile:'Common/BMIAgerevPercentile',
criticalityStatusCodes:'Medications/AllergyCriticality',
HCAgeInfo:'common/HCAgeInfo',
ProcedureReasons:'common/ProcedureReasons',
// USers without Locations
staffWithoutLocations:'Staff/WithoutLocationStaff',
physiciansWithoutLocations:'physicians/WithoutLocationPhysician',
SCTBodyStructure:'Problems/SCTBodyStructure',
ProcedureEventStatus:'Master/ProcedureEventStatus',
patientAllVisitsByPatientId: 'Patient/PatientAllVisitsByPatientId',
sexObservation:'Patient/SexObservation',
  
  roleName: 'Master/RollName',
  CCDACodeList: 'Physicians/CCDACodeList',
  CCDAValueSet:'Master/CCDAValueSet',
  CCDAValueSetSearch :'Master/CCDAValueSetSearch',
  lifeCycleStatus:'Master/LifeCycleStatus',
  goalAchivements:'Master/GoalAchievement',
  roleCodes:'Master/CCDASearchByCode',
  clinicalReconciliationReview:'common/PatientMedRecon',
  patientHIElectronicAccess:'AutoMeasures/PatientHIElectronicAccess',
  checkNpi:'Physicians/CheckNPI',
  // activityStatus:'Master/ValueSetOID',
//patient ssn
  patientSSN:'Patient/PatientSSN',

  // lastname,firstname,dob duplicate check
  patientDuplicateCheck:'Patient/CheckPatientInfo',

  //filter patient data 
  patientFilterData:'Patient/PatientFilterViewDashboard',

    //FAQs
manageFAQFiles:'VideoFile/Videos',

//spmStatus dropdown for lab orders
spmStatus:'Master/SPMStatus',

//EncounterStatus dropdown for add visit
 encounterStatus:'Master/EncounterStatus',

 //npi for  add-physician 
  checkPhysicianNpi: 'Physicians/CheckPhyNPI', 

  //#region VENDER
  vender: 'Vendor/Vendor',
  approveVender: 'Vendor/ApproveVendor',
  //#endregion VENDER
    MapCDSRules:'CDS/MapCDSRules',
    deleteQrdaImportData:'QRDA/DeleteQRDAFiles',
    problemSet:'QRDA/ValusetOIDProblems',
  patientOtherInfo: 'Patient/PatientOtherInfo',
  patientAdditional: 'Patient/PatientAdditional',
  // referenceccdaservice:'referenceccdaservice'

  medicationCount: 'TrnMedications/MedCounts',
  CustomCCDAElement:'Physicians/CustomCCDAElement',
  RadiationTreatment:'ReportableCancer/RadiationOncology',
  RadiationCancer:'ReportableCancer/GetRadiationOncology',
 coverageType:'Master/CoverageType', 
 Fms:'Master/FMStatus',
  sitesGroup:'ReportableCancer/StageGroups',
  transmit:'ReportableCancer/Transmit_Cancer',
  pregnancyStatus:'Master/PregnancyStatus',
  pregnancyIntention:'Master/PregnancyIntent',
  // fHIRDeviceTypes:'Master/ValueSetOID',

  patientReportsMeasures:'NHSNHL7/NHSNAROAUPReports',

//#region  organization
contactPointSystem:'Master/ContactPointSystem',
careplan:'Master/CarePlanCategory',
nameUse:'Master/NameUse',
//  addressType:'Master/AddressType',
addressUse:'Master/AddressUse',
organizationInfomationData:'Master/OrganizationInfo',
  panelOrdersHistory:'Master/PanelOrders',
  questionnaireData:'History/QuestionnaireResponse',
  orderSetEsign:'OrderSets/eSign',
  interpretation:'Master/InterpretationResults',

  erPatientCount:'ERDashboard/PatientCount',
  defaultMenu:'Menus/DefaultMenus',
  dashboardMenu: 'Menus/DashboardMenu',
  existingMenuStatus: 'Menus/ExistingMenuStatus',
  existingSidebarMenuStatus: 'Menus/ExistingSideMenuStatus',
  checkSelectedData:'Template/ExistPainSiteStatus',
  //nhsn report type
  patientDrugReport:'Reports/DrugReport',
  nhsnReportDownload:'NHSNHL7/DownloadNHSNReports',  
  Mst_ICUControl:'ICU/Mst_ICUControl',
  Mst_IcuFlowChartItemsLists:'ICU/Mst_IcuFlowChartItemsLists',
  Map_Nursing_ICUFLowChartItemType:'ICU/Map_Nursing_ICUFLowChartItemType',
  MstIcuControlsNursing:'ICU/MstIcuControlsNursing',
  notificationCount :'ERDashBoard/HomeNotification',
  InlineOrderStatus:'OrderSets/InlineOrderStatus',
  ReviewStatus:'Template/ReviewStatus',
  Audio_DiscussionClini:'AudioFile/Audio_Discussion',
  pregnantData:'ERDashboard/PatientPregnancyStatus',
  lastActionsMedications:'TrnMedications/Marinfo',

  medicationPrintLabels: 'TrnMedications/MedicationPrintLabels',
  deleteCancerRegistries:'ReportableCancer/DeleteRadiationOncology',
  deletePathalogy:'ReportableCancer/DeleteClinicalAndPathalogy',
  fhirRevokeRequest:'Patient/FhirStatus',
  patientRequests:'Patient/PatientRequests',
  fhirAuditLog:'AuditEvent',
  refreshToken: '.well-known/logoutrealm',
  checkCancerDownload:'ReportableCancer/ProblemsListByCancerPatient',
  FlowSheets:'Template/FlowSheets',
  saveFontSize:'Patient/UserFontSettings',
  Patient_Merge:'patient/Patient_Merge',
  PatientMerge:'Patient/PatientMerge',
  PatietnMergerdoc:'Patient/PatietnMergerdoc',
  FormPatientCount:'patient/FormPatientCount' ,
  handlefalconrequests:'notes/falconrequests',
  getFalconNotes:'notes/falconrequest',
  falconNotesLog:'notes/falconrequest/stats',
  // FormPatientCount:'patient/FormPatientCount',
  charges:'Master/chargeCodes',
  chargesData:'ClaimCharges/claimcharge',
  getChargesData:'ClaimCharges/allClaimcharges',
  noteTemplates:'note-templates/falcon',
  segmentsSearch:'notes/falcon/segments/search',
  clinoteSegmentsSearch:'notes/clinote/segments/search',
    codeStatusQueue:'ERDashboard/CodeStatusQueue',
audiotranscribe:'audio/transcribe',
  adtOrderStatus: 'OrderSets/ADTOrderStatus',
  medicationByPatient:'Reports/PatientMedReport',
  vaccineReport:'Reports/VaccineReport',



  // Beds Icons
  cleaningBed: '/Assets?path=Images/assets/images/auth/cleaning.png',
  cleaningSelected: '/Assets?path=Images/assets/images/auth/cleaning-selected.png',
  emptyBed: '/Assets?path=Images/assets/images/auth/empty.png',
  emptyBedSelected: '/Assets?path=Images/assets/images/auth/selected.png',
  occupiedOnePatient: '/Assets?path=Images/assets/images/auth/occupied-one-patient.png',
  occupiedOnePatientSelected: '/Assets?path=Images/assets/images/auth/occupied-one-patient-selected.png',
  occupiedOneWaiting: '/Assets?path=Images/assets/images/auth/occupied-one-waiting.png',
  occupiedWaitingSelected: '/Assets?path=Images/assets/images/auth/occupied-waiting-selected.png',
  repairBed: '/Assets?path=Images/assets/images/auth/repair.png',
  repairSelected: '/Assets?path=Images/assets/images/auth/repair-selected.png',
  twoPatient: '/Assets?path=Images/assets/images/auth/two-patient.png',
  twoPatientSelected: '/Assets?path=Images/assets/images/auth/two-patient-selected.png',
  waitingBed: '/Assets?path=Images/assets/images/auth/waiting.png',
  waitingSelected: '/Assets?path=Images/assets/images/auth/waiting-selected.png',

  HIM_Doctypes: 'Master/HIM_Doctypes',

  cloneAssignPermission: 'AssignPermission/ClonePermission',
  cloneMenu: 'Menus/Clone_Menus',
  NatureOfOrders:'Master/NatureOfOrders',
  SignOrSymptoms:'Master/SignOrSymptoms',
  MSTPOCTest:'LabResults/MSTPOCTest',
  
  PatientPointOfCare:'LabResults/PatientPointOfCare' ,
  labaratory:'LabResults/LaboratoryWorklist',
  TRNPOCOrder:'LabResults/TRNPOCOrder',
  PatientPOC:'LabResults/PatientPOC',
  bcmaReport:'TrnMedications/PatientMedicationsRec',
  bcmaReportPatientSearch:'Patient/NursingStationPatientSearch',
  downloadbcmaReport:'TrnMedications/PatientReportInfo',
  dietOrdersByPatient:'OrderSets/PatientDietOrders',
  FlowsheetHeaderJsonData:'Template/FlowsheetHeaderJsonData',
  ehrNoteTemplates:'note-templates/ehr',
  notesections:'notesections',
  customEhrNoteTemplates:'note-templates/ehr/custom',
  saveEhrNoteTemplates:'note-templates/ehr',
  masterEhrNoteTemplate:'note-templates/default/ehr',
  MSTOrderSetControlData:'OrderSets/MSTOrderSetControlData',
  duplicateCheckOfEDU:'EducationResources/EduCategoryMnemonicStatus',
  educationDetails:'EducationResources/PatientEduTrainings',
  deleteEduationData:'EducationResources/PatientEduTrainings',
  downloadEduData:'EducationResources/PatientEduDocPreviewAndDownload',
  technicianList:'Radiology/Technicians',
  MarInfoByMedicationRowid:'TrnMedications/MarInfoByMedicationRowid',
  patientInfoView:'Patient/NewPatientInformation',
  guarantorInformationView:'Patient/GuarantorDetails',
  emergencyInformationView:'Patient/DetailEmergencyInfo',
  visitPatientInfo:'Patient/PatientVisitDetails',
   Notification:'Notifications/Notification',
  additionalTimeInterval: 'Template/FlowsheetIntervals',
  PatientFlowsheetPrintReport:'Template/PatientFlowsheetPrintReport',
  MstTemplateNamesListByTemplateCategoryId:'Template/MstTemplateNamesListByTemplateCategoryId',
  credentials:'Physicians/PhysicianDegree',
  physpecaility:'Physicians/Speciality',
  MstTemplateNameByTemplateCategoryId:'Template/MstTemplateNameByTemplateCategoryId',
  demographicsPrint:'Patient/PatientDemographicInfo',
  Alert_Drug_lab_Interference:'TrnMedications/Alert_Drug_lab_Interference',
  commonNotes:'Common/VisitNotes',
  VitalSignOrder:'VitalSigns/VitalSignOrder',
  marReportPrint:'Reports/MARReportData',
  patientReportPrint:'Patient/PatientReportData',
  IVPBLVPReports:'Reports/IVPBLVPReports',
  cenusNursingStation:'Reports/CensusByNursingStationtData',
  DrugAlerts:'DDIInteractions/DrugAlerts',
  PharmacyData:'TrnMedications/PharmacyData',
  dischargeReportPrint:'Reports/DischargeReports',
  MapDocNusTemplateByRole:'Template/MapDocNusTemplateByRole',
  bcmaReportpdf:'Reports/BCMAReportData',
  physicianNotification:'Reports/PhysicianNotification',
  ActiveInactiveMstTemplateNameByTemplateCategoryId:'Template/ActiveInactiveMstTemplateNameByTemplateCategoryId',
  MstTemplateNamesList:'Template/MstTemplateNamesList',
  flowsheetFrequentlyUsed: 'Template/FlowsheetAccessDetails',
  reconcileStatusTooltip:'OrderSets/ADTOrderAvailableStatus',
  incompeleteDocumentsReport:'Reports/IncompletedNotes',
  incompeleteOrders:'Reports/IncompletedOrders', 
  physicianNotificationPdf:'Reports/PhysicianNotifications',
  incompeleteOrdersPdf:'Reports/ExportIncompleteOrders',
  incompeleteDocumentsPdf:'Reports/ExportIncompleteNotes',

}